webpackJsonp([2,0],{

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Created by jv on 04/01/2017.
	 */
	var config = __webpack_require__(348);
	
	var utils = {};
	var queryParams = void 0;
	
	(function (Utils) {
	  var MAX_UID = 1000000;
	
	  Utils.UUID = function () {
	    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
	      var r = Math.random() * 16 | 0,
	          v = c === "x" ? r : r & 0x3 | 0x8;
	      return v.toString(16);
	    });
	  };
	
	  Utils.generateUIDShort = function () {
	    return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
	  };
	
	  Utils.generateElementId = function (prefix) {
	    do {
	      prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
	    } while (document.getElementById(prefix));
	
	    return prefix;
	  };
	
	  Utils.redirect = function (link) {
	    window.location.href = link;
	  };
	
	  // %note: might be better to use https://www.npmjs.com/package/lodash for most of these utility functions
	  Utils.isUndefined = function (obj) {
	    return typeof obj === "undefined";
	  };
	
	  Utils.isDefined = function (obj) {
	    return !Utils.isUndefined(obj);
	  };
	
	  Utils.isNull = function (obj) {
	    return typeof obj === "undefined" || obj === null;
	  };
	
	  Utils.isNotNull = function (obj) {
	    return !Utils.isNull(obj);
	  };
	
	  Utils.isNullOrEmpty = function (str) {
	    return Utils.isNull(str) || str === "";
	  };
	
	  Utils.isString = function (value) {
	    return Utils.isNotNull(value) && typeof value === "string";
	  };
	
	  Utils.isBoolean = function (value) {
	    return value === true || value === false;
	  };
	
	  Utils.isNumber = function (value) {
	    return Utils.isNotNull(value) && !isNaN(value) && typeof value === "number";
	  };
	
	  Utils.isArray = function (obj) {
	    return Utils.isNotNull(obj) && Array.isArray(obj);
	  };
	
	  Utils.isObject = function (obj) {
	    return Utils.isNotNull(obj) && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object";
	  };
	
	  Utils.isMomentObject = function (obj) {
	    return Utils.isObject(obj) && obj.hasOwnProperty("_isAMomentObject") && obj._isAMomentObject === true;
	  };
	
	  Utils.isFunction = function (obj) {
	    return typeof obj === "function";
	  };
	
	  Utils.isValidEmail = function (email) {
	    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return re.test(email);
	  };
	
	  Utils.defaultFor = function (value, defaultValue, type) {
	    if (Utils.isNotNull(type) && (typeof value === "undefined" ? "undefined" : _typeof(value)) !== type) {
	      return defaultValue;
	    }
	
	    return Utils.isNotNull(value) ? value : defaultValue;
	  };
	
	  Utils.stringToInt = function (value) {
	    if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value)) {
	      return Number(value);
	    }
	
	    return NaN;
	  };
	
	  Utils.stringToBoolean = function (value) {
	    return Utils.isNotNull(value) && (value === "true" || value === true) ? true : false;
	  };
	
	  Utils.parseFloat = function (value) {
	    var parsedValue = parseFloat(value);
	
	    if (Utils.isNumber(parsedValue)) {
	      return parsedValue;
	    }
	
	    return null;
	  };
	
	  Utils.stringifyJSON = function (obj, replacer, space) {
	    return JSON.stringify(obj, replacer, space);
	  };
	
	  Utils.parseJSON = function (str, safe) {
	    if (safe) {
	      try {
	        var objValue = JSON.parse(str);
	        return objValue;
	      } catch (e) {
	        return str;
	      }
	    } else {
	      return JSON.parse(str);
	    }
	  };
	
	  Utils.rgbToHex = function (r, g, b) {
	    if (r > 255 || g > 255 || b > 255) {
	      throw "Invalid color component";
	    }
	
	    var hex = (r << 16 | g << 8 | b).toString(16);
	    return "#" + ("000000" + hex).slice(-6);
	  };
	
	  Utils.hexToRgb = function (hex) {
	    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
	    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
	      return r + r + g + g + b + b;
	    });
	
	    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	    return result ? {
	      r: parseInt(result[1], 16),
	      g: parseInt(result[2], 16),
	      b: parseInt(result[3], 16)
	    } : null;
	  };
	
	  Utils.hexToCmyk = function (hex) {
	    var computedC = void 0;
	    var computedM = void 0;
	    var computedY = void 0;
	    var computedK = void 0;
	
	    hex = hex.replace("#", "");
	
	    if (hex.length !== 6) {
	      return null;
	    }
	    if (/[0-9a-f]{6}/i.test(hex) !== true) {
	      return null;
	    }
	
	    var r = parseInt(hex.substring(0, 2), 16);
	    var g = parseInt(hex.substring(2, 4), 16);
	    var b = parseInt(hex.substring(4, 6), 16);
	
	    // BLACK
	    if (r === 0 && g === 0 && b === 0) {
	      return {
	        c: 0,
	        m: 0,
	        y: 0,
	        k: 1
	      };
	    }
	
	    computedC = 1 - r / 255;
	    computedM = 1 - g / 255;
	    computedY = 1 - b / 255;
	
	    var minCMY = Math.min(computedC, Math.min(computedM, computedY));
	
	    computedC = (computedC - minCMY) / (1 - minCMY);
	    computedM = (computedM - minCMY) / (1 - minCMY);
	    computedY = (computedY - minCMY) / (1 - minCMY);
	    computedK = minCMY;
	
	    return {
	      c: computedC,
	      m: computedM,
	      y: computedY,
	      k: computedK
	    };
	  };
	
	  Utils.roundNumber = function (number, decimals) {
	    if (Utils.isNumber(number)) {
	      var rounder = Math.pow(10, decimals);
	      return Math.round(number * rounder) / rounder;
	    }
	
	    return NaN;
	  };
	
	  Utils.format = function (format) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return format.replace(/{(\d+)}/g, function (match, number) {
	      return utils.isDefined(args[number]) ? args[number] : match;
	    });
	  };
	
	  Utils.formatMoney = function (value, currency) {
	    if (currency.beforePrice) {
	      return currency.escapedSymbol + "" + utils.formatNumber(utils.roundNumber(value, 2), { decimalLength: 2 });
	    }
	
	    return utils.formatNumber(utils.roundNumber(value, 2), { decimalLength: 2 }) + "" + currency.symbol;
	  };
	
	  Utils.formatNumber = function (value, options) {
	    if (!utils.isNumber(value)) return null;
	
	    options = utils.isNotNull(options) ? options : {};
	
	    var decimalLength = ~~options.decimalLength,
	        groupLength = utils.isNumber(options.groupLength) ? options.groupLength : 3,
	        groupDelimiter = options.groupDelimiter || ",",
	        decimalDelimiter = options.decimalDelimiter;
	
	    var re = "\\d(?=(\\d{" + groupLength + "})+" + (decimalLength > 0 ? "\\D" : "$") + ")",
	        num = value.toFixed(Math.max(0, decimalLength));
	
	    return (decimalDelimiter ? num.replace(".", decimalDelimiter) : num).replace(new RegExp(re, "g"), "$&" + groupDelimiter);
	  };
	
	  Utils.getRandomIntInclusive = function (min, max) {
	    min = Math.ceil(min);
	    max = Math.floor(max);
	    return Math.floor(Math.random() * (max - min + 1)) + min;
	  };
	
	  Utils.getContrastYIQ = function (hexColor) {
	    hexColor = hexColor.replace("#", "");
	
	    var r = parseInt(hexColor.substr(0, 2), 16);
	    var g = parseInt(hexColor.substr(2, 2), 16);
	    var b = parseInt(hexColor.substr(4, 2), 16);
	    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
	
	    return yiq;
	  };
	
	  Utils.getContrastColor = function (color, options) {
	    options = Utils.isNotNull(options) ? options : {};
	
	    var yiqColor = Utils.getContrastYIQ(color);
	
	    var threshold = Utils.isNumber(options.threshold) ? options.threshold : 256 / 2;
	    var belowThresholdColor = Utils.isNotNull(options.belowThresholdColor) ? options.belowThresholdColor : "#ffffff";
	    var aboveThresholdColor = Utils.isNotNull(options.aboveThresholdColor) ? options.aboveThresholdColor : "#000000";
	
	    return yiqColor < threshold ? belowThresholdColor : aboveThresholdColor;
	  };
	
	  Utils.invertColor = function (hexColor) {
	    hexColor = hexColor.replace("#", ""); // remove #
	    hexColor = parseInt(hexColor, 16); // convert to integer
	    hexColor = 0xFFFFFF ^ hexColor; // invert three bytes
	    hexColor = hexColor.toString(16); // convert to hex
	    hexColor = ("000000" + hexColor).slice(-6); // pad with leading zeros
	    hexColor = "#" + hexColor; // prepend #
	
	    return hexColor;
	  };
	
	  Utils.arraysAreEqual = function (arr1, arr2) {
	    if (arr1 === arr2) return true;
	    if (utils.isNull(arr1) || utils.isNull(arr2)) return false;
	    if (arr1.length !== arr2.length) return false;
	
	    for (var i = 0; i < arr1.length; i++) {
	      if (arr1[i] !== arr2[i]) return false;
	    }
	
	    return true;
	  };
	
	  Utils.resetFormElement = function (el) {
	    $(el).wrap("<form></form>").closest("form").get(0).reset();
	    $(el).unwrap();
	  };
	
	  Utils.setButtonLoading = function ($element, flag) {
	    if (utils.isNull($element) || !$element.length) return;
	
	    $element.prop("disabled", flag);
	
	    if (flag) {
	      $element.addClass("btn-loading");
	    } else {
	      $element.removeClass("btn-loading");
	    }
	  };
	
	  Utils.getServiceUrl = function (path) {
	    return config.serviceBaseURL + path;
	  };
	
	  Utils.luhnCheck = function (str) {
	    return str.split("").reduceRight(function (prev, curr, idx) {
	      if ((idx + 1) % 2 !== 0) {
	        curr = (curr * 2).toString().split("").reduce(function (p, c) {
	          return +p + +c;
	        });
	      }
	      return +prev + +curr;
	    }) % 10 === 0;
	  };
	
	  Utils.getQueryParam = function (name) {
	    return queryParams[name];
	  };
	
	  Utils.getUrlPath = function () {
	    return window.location.pathname;
	  };
	
	  Utils.getPathSection = function (index) {
	    var path = window.location.pathname;
	    var pathSections = path.split("/");
	
	    for (var i = 0; i < pathSections.length; i++) {
	      var pathSection = pathSections[i];
	
	      if (Utils.isNullOrEmpty(pathSection)) {
	        index++;
	        continue;
	      }
	
	      if (i + 1 === index) {
	        return pathSection;
	      }
	    }
	
	    return null;
	  };
	
	  Utils.getPathSectionLength = function () {
	    var path = window.location.pathname;
	    var pathSections = path.split("/");
	
	    return pathSections.length;
	  };
	
	  Utils.btoa = function (stringToEncode) {
	    return Utils.isNotNull(stringToEncode) ? window.btoa(encodeURIComponent(stringToEncode)) : null;
	  };
	
	  Utils.atob = function (stringToDecode) {
	    return Utils.isNotNull(stringToDecode) ? decodeURIComponent(window.atob(stringToDecode)) : null;
	  };
	
	  Utils.debounce = function (func, wait, immediate, context) {
	    var timeout = void 0;
	    return function () {
	      context = context || this;
	      var args = arguments;
	      var later = function later() {
	        timeout = null;
	        if (!immediate) func.apply(context, args);
	      };
	
	      var callNow = immediate && !timeout;
	      clearTimeout(timeout);
	      timeout = setTimeout(later, wait);
	      if (callNow) func.apply(context, args);
	    };
	  };
	
	  // returns a number of seconds as string "mm:ss"
	  Utils.getTimeString = function (totalSeconds) {
	    var hours = Math.floor(totalSeconds / 3600);
	    var minutes = Math.floor(totalSeconds % 3600 / 60);
	    var seconds = totalSeconds % 60;
	
	    var secondsString = seconds < 10 ? "0" + seconds : "" + seconds;
	
	    if (hours > 0) {
	      var minutesString = minutes < 10 ? "0" + minutes : "" + minutes;
	      return hours + ":" + minutesString + ":" + secondsString;
	    } else {
	      return minutes + ":" + secondsString;
	    }
	  };
	})(utils);
	
	// Load query parameters once
	(window.onpopstate = function () {
	  var match = void 0,
	      pl = /\+/g,
	      // Regex for replacing addition symbol with a space
	  search = /([^&=]+)=?([^&]*)/g,
	      decode = function decode(s) {
	    return decodeURIComponent(s.replace(pl, " "));
	  },
	      query = window.location.search.substring(1);
	
	  queryParams = {};
	  while (match = search.exec(query)) {
	    var name = decode(match[1]);
	    var value = decode(match[2]);
	
	    if (queryParams.hasOwnProperty(name)) {
	      if (!utils.isArray(queryParams[name])) {
	        // Make it an array
	        queryParams[name] = [queryParams[name]];
	      }
	
	      queryParams[name].push(value);
	    } else {
	      queryParams[name] = value;
	    }
	  }
	})();
	
	module.exports = utils;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 25/07/2017.
	 */
	var utils = __webpack_require__(2);
	
	var hasLogged = false;
	
	module.exports = function (debug) {
	  var Logger = {};
	
	  // function init(force)
	  // {
	  //   if(debug || __DEVELOPMENT__ || force)
	  //   {
	  //     for(var m in console)
	  //     {
	  //       if(utils.isFunction(console[m]))
	  //       {
	  //         Logger[m] = console[m].bind(window.console);
	  //       }
	  //     }
	  //
	  //     Logger.cssLog = function(...args)
	  //     {
	  //       if(!hasLogged)
	  //       {
	  //         Logger.info("If you want to preserve the correct file name and line number stuff then you can add the logger.js script to the blackbox (chrome)\nThis basically removes the file from debugging, read: https://developer.chrome.com/devtools/docs/blackboxing");
	  //         hasLogged = true;
	  //       }
	  //
	  //       args = Logger.cssify.apply(null, args);
	  //       return Logger.log.apply(null, args);
	  //     }
	  //   }
	  //   else
	  //   {
	  //     for(var m in console)
	  //     {
	  //       if(utils.isFunction(console[m]))
	  //       {
	  //         Logger[m] = () => {};
	  //       }
	  //     }
	  //
	  //     Logger.cssLog = () => {};
	  //   }
	  // }
	  //
	  // init();
	
	  function isDebug() {
	    if (!window.console || !window.console.info || !window.console.debug || !window.console.error || !window.console.log || !window.console.warn || !window.console.trace) {
	      return false;
	    }
	
	    return debug || (false) || window.__PRODUCTION_LOGGING__;
	  }
	
	  function firstLogCheck() {
	    if (!hasLogged) {
	      console.log("If you want to preserve the correct file name and line number stuff then you can add the logger.js script to the blackbox (chrome)\nThis basically removes the file from debugging, read: https://developer.chrome.com/devtools/docs/blackboxing");
	      hasLogged = true;
	    }
	  }
	
	  Logger.trace = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        console.trace.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.debug = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        console.debug.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.log = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	          args[_key3] = arguments[_key3];
	        }
	
	        console.log.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.info = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	          args[_key4] = arguments[_key4];
	        }
	
	        console.info.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.cssLog = function () {
	    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      args[_key5] = arguments[_key5];
	    }
	
	    if (isDebug()) {
	      firstLogCheck();
	      args = Logger.cssify.apply(null, args);
	
	      try {
	        console.log.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.warn = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	          args[_key6] = arguments[_key6];
	        }
	
	        console.warn.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.error = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	          args[_key7] = arguments[_key7];
	        }
	
	        console.error.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.cssify = function () {
	    for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	      args[_key8] = arguments[_key8];
	    }
	
	    if (args.length > 1) {
	      var css = args[args.length - 1];
	      args.splice(args.length - 1, 1);
	
	      var cssString = "";
	
	      for (var key in css) {
	        if (css.hasOwnProperty(key)) {
	          cssString += key + ": " + css[key] + ";";
	        }
	      }
	
	      if (utils.isString(args[0])) {
	        if ((args[0].match(/%c/g) || []).length === 0) {
	          // Css applies to the whole text so just insert the css at the second (first is the text) and last place
	          args[0] = "%c" + args[0] + "%c";
	
	          args.splice(1, 0, cssString);
	          //Resets the css
	          args.push("");
	        } else if (args.length === 1) {
	          //If there's only text with no arguments, same as before, insert css at second and last place
	          args.push(cssString);
	          //Resets the css
	          args.push("");
	        } else {
	          // Determine where the css arguments need to go in the array
	          /*
	             %s - String.
	             %d - Number (integer or floating point value).
	             %i - Integer.
	             %f - Floating point value.
	             %j - JSON. Replaced with the string '[Circular]' if the argument contains circular references.
	             %o - JavaScript Object
	           */
	
	          // position BEFORE the first %c
	          var startPos = args[0].indexOf("%c");
	          // position AFTER the last %c
	          var endPos = args[0].lastIndexOf("%c") + 2;
	
	          if (startPos !== -1 && endPos !== -1 && startPos !== endPos) {
	            var leftSubString = args[0].substring(0, startPos);
	            var rightSubString = args[0].substr(endPos);
	            // Find all format occurrences
	            var firstInsert = (leftSubString.match(/(%s|%d|%i|%f|%j|%o)/g) || []).length;
	            var secondInsert = (rightSubString.match(/(%s|%d|%i|%f|%j|%o)/g) || []).length;
	
	            // Account for the text that's in the first position
	            args.splice(firstInsert + 1, 0, cssString);
	            //Resets the css
	            args.splice(args.length - secondInsert, 0, "");
	          }
	        }
	      }
	
	      return args;
	    }
	  };
	
	  // http://www.flatuicolorpicker.com/
	  /*
	    SUMMER SKY
	    1E8BC3
	    30, 139, 195
	   */
	  Logger.infoCss = {
	    "background-color": "#1E8BC3",
	    "color": "#ffffff"
	  };
	
	  /*
	    EUCALYPTUS
	    26A65B
	    38, 166, 91
	   */
	  Logger.successCss = {
	    "background-color": "#26A65B",
	    "color": "#ffffff"
	  };
	
	  /*
	    SANDSTORM
	    F9BF3B
	    249, 191, 59
	   */
	  Logger.warningCss = {
	    "background-color": "#F9BF3B",
	    "color": "#000000"
	  };
	
	  /*
	    FLAMINGO
	    EF4836
	    239, 72, 54
	   */
	  Logger.errorCss = {
	    "background-color": "#EF4836",
	    "color": "#ffffff"
	  };
	
	  return Logger;
	};
	
	/*
	Examples:

	logger.info("Hi");
	logger.warn("Warning");
	logger.error("Error");
	logger.cssLog("Hi %s", "Jan", logger.successCss);
	logger.cssLog("Hi %cthere Jan%c", logger.warningCss);
	logger.cssLog("Hi there %s, my name is %c%s and I am%c %d", "Jan", "Someone", 23, logger.errorCss);
	*/

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * User: jv
	 * Date: 12/05/16
	 * Time: 12:56
	 */
	var utils = __webpack_require__(2);
	var log = __webpack_require__(4)();
	var CONSTANTS = __webpack_require__(55);
	var localeReq = __webpack_require__(10);
	
	var LanguageManager = {};
	
	(function (LanguageManager) {
	  var locale = null;
	  var localeMap = null;
	
	  LanguageManager.init = function () {
	    locale = localStorage.getItem("locale");
	
	    var tmpLocale = utils.getQueryParam("locale");
	    if (!utils.isNullOrEmpty(tmpLocale)) {
	      locale = tmpLocale;
	      localStorage.setItem("locale", locale);
	    }
	
	    if (utils.isNullOrEmpty(locale) || !localeExists(locale)) {
	      locale = CONSTANTS.DEFAULT_LOCALE;
	    }
	
	    $("html").addClass(locale);
	
	    _init();
	  };
	
	  function _init() {
	    getLocaleMap();
	    applyLocale();
	    $(".page-wrapper").show();
	
	    if (utils.isFunction(LanguageManager.onInit)) {
	      LanguageManager.onInit();
	    }
	
	    if (utils.isFunction(LanguageManager.onInitGlobal)) {
	      LanguageManager.onInitGlobal();
	    }
	  }
	
	  LanguageManager.onInit = null;
	
	  LanguageManager.onInitGlobal = null;
	
	  LanguageManager.changeLocale = function (newLocale) {
	    if (localeExists(newLocale)) {
	      $("html").removeClass(locale).addClass(newLocale);
	      locale = newLocale;
	      localStorage.setItem("locale", locale);
	      LanguageManager.localize();
	    } else {
	      throw "Locale does not exist";
	    }
	  };
	
	  LanguageManager.getCurrentLocale = function () {
	    return locale;
	  };
	
	  LanguageManager.localize = function () {
	    if (!localeMapIsDefined() || locale !== localeMap.locale) {
	      getLocaleMap();
	      applyLocale();
	    } else {
	      applyLocale();
	    }
	  };
	
	  function getLocaleMap() {
	    try {
	      log.info("Trying to fetch locale '%s'", locale);
	
	      var localeRequire = "./" + locale + ".json";
	
	      log.info("'%s' is in %o ? %s", localeRequire, localeReq.keys(), $.inArray(localeRequire, localeReq.keys()) !== -1);
	
	      if ($.inArray(localeRequire, localeReq.keys()) !== -1) {
	        var tmpLocaleMap = localeReq(localeRequire);
	
	        log.info("Successfully fetched locale map for locale [%s]: %o", locale, tmpLocaleMap);
	
	        localeMap = tmpLocaleMap;
	      } else if (locale !== "nl-BE" && $.inArray("./nl-BE.json", localeReq.keys()) !== -1) {
	        $("html").removeClass(locale).addClass("nl-BE");
	        locale = "nl-BE";
	        localStorage.setItem("locale", locale);
	        getLocaleMap(callback);
	      } else {
	        log.error("Couldn't find locale [%s] in known locale list: %o", locale, localeReq.keys());
	        alert("Localisation could not be loaded, contact your site administrator.");
	      }
	    } catch (e) {
	      console.error(e);
	    }
	  }
	
	  function localeExists(pLocale) {
	    var localeRequire = "./" + pLocale + ".json";
	
	    return $.inArray(localeRequire, localeReq.keys()) !== -1;
	  }
	
	  LanguageManager.applyLocale = function (selector) {
	    if (localeMapIsDefined() && locale === localeMap.locale) {
	      // Add back to include the selector itself
	      applyLocale($(selector).find("[data-localize]").addBack(selector).filter("[data-localize]"));
	    }
	  };
	
	  function applyLocale($element) {
	    $element = utils.isNotNull($element) ? $element : $("[data-localize]");
	
	    $element.each(function () {
	      var element = $(this);
	      //let key = $(this).data("localize");
	      var key = $(this).attr("data-localize");
	
	      if ((typeof localeMap === "undefined" ? "undefined" : _typeof(localeMap)) === "object" && localeMap.localization.hasOwnProperty(key)) {
	        applyElementLocalization(element, localeMap.localization[key]);
	      } else {
	        applyElementLocalization(element, key);
	      }
	    });
	  }
	
	  function applyElementLocalization(element, text) {
	    var localizeTo = element.data("localize-to");
	    var isFormInput = element.is("input") || element.is("textarea");
	
	    if (isFormInput) {
	      //element.attr("placeholder", text.toLowerCase());
	      element.attr("placeholder", text);
	    }
	
	    if (!utils.isNullOrEmpty(localizeTo)) {
	      localizeTo = localizeTo.split(";");
	
	      for (var i = 0; i < localizeTo.length; i++) {
	        if (localizeTo[i] === "text-node") {
	          replaceNodeText(element, text);
	        } else {
	          element.attr(localizeTo[i], text);
	        }
	      }
	    } else if (!isFormInput) {
	      replaceNodeText(element, text);
	    }
	  }
	
	  function replaceNodeText(element, text) {
	    element.html(text);
	  }
	
	  LanguageManager.getValueForKey = function (key) {
	    if (localeMapIsDefined() && localeMap.localization.hasOwnProperty(key)) {
	      return localeMap.localization[key];
	    } else {
	      return key;
	    }
	  };
	
	  function localeMapIsDefined() {
	    return utils.isObject(localeMap) && localeMap.hasOwnProperty("locale") && localeMap.hasOwnProperty("localization");
	  }
	})(LanguageManager);
	
	module.exports = LanguageManager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _es6Promise = __webpack_require__(45);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _navigationUtils = __webpack_require__(147);
	
	var _navigationUtils2 = _interopRequireDefault(_navigationUtils);
	
	var _modal = __webpack_require__(354);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _materialService = __webpack_require__(116);
	
	var _materialService2 = _interopRequireDefault(_materialService);
	
	var _curriculumObjectiveService = __webpack_require__(145);
	
	var _curriculumObjectiveService2 = _interopRequireDefault(_curriculumObjectiveService);
	
	var _mediaAssetService = __webpack_require__(218);
	
	var _mediaAssetService2 = _interopRequireDefault(_mediaAssetService);
	
	var _storageController = __webpack_require__(21);
	
	var _storageController2 = _interopRequireDefault(_storageController);
	
	var _cookieconsentController = __webpack_require__(349);
	
	var _cookieconsentController2 = _interopRequireDefault(_cookieconsentController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 10/03/2017.
	 */
	// Styles
	__webpack_require__(572);
	__webpack_require__(259);
	__webpack_require__(571);
	
	// js
	//require("script-loader!Sources/misc/google-analytics");
	__webpack_require__(367);
	// Polyfill promises
	__webpack_require__(570);
	__webpack_require__(355);
	// These libs aren't nice and put themselves in window instead of being able to be required into a variable
	// prepend the JS files with 'script-loader?' to require them like they were added with ordinary <script> tags
	// https://webpack.github.io/docs/shimming-modules.html
	__webpack_require__(762); // Is used to check if browser is outdated
	__webpack_require__(329); // requires the cookieconsent library like it was a script tag in the html
	__webpack_require__(761);
	
	// Dark mode favicon
	var faviconDark = __webpack_require__(766);
	
	// Global app styles (after external libs)
	__webpack_require__(583);
	
	var log = __webpack_require__(4)();
	
	var Shared = {};
	
	(function (Shared) {
	  Shared.init = function () {
	    if (Shared.isOutdated()) {
	      log.info("Browser is outdated, redirecting to /outdated");
	      _utils2.default.redirect("/outdated");
	    }
	
	    var userData = Shared.getUserData();
	
	    if (_utils2.default.isNotNull(userData)) {
	      log.info("User: %o", userData);
	    }
	
	    if (false) {} else {
	      // if(utils.isNotNull(userData))
	      // {
	      //   ga("set", "userId", userData.userKey);
	      //   ga("set", "dimension1", userData.userKey);
	      // }
	      //
	      // ga("send", "pageview");
	    }
	
	    setUpMatchMedia();
	
	    // Set default nav link highlight (try to find it based on current path
	    _navigationUtils2.default.setNavHighlight();
	
	    setUpFragmentImages();
	
	    _languageManager2.default.init();
	  };
	
	  _languageManager2.default.onInitGlobal = function () {
	    /*
	    try
	    {
	    cookieconsent.initialise({
	      palette: {
	        popup: {
	          background: "#222222",
	          text: "#ffffff"
	        },
	        button: {
	          background: "#e41d36",
	          text: "#ffffff"
	        }
	      },
	      theme: "classic",
	      content: {
	        message: LanguageManager.getValueForKey("cookies.message"),
	        dismiss: LanguageManager.getValueForKey("cookies.button.text"),
	        link: LanguageManager.getValueForKey("cookies.link.text"),
	        href: LanguageManager.getValueForKey("cookies.link")
	      }
	    });
	    }
	    catch(e)
	    {
	    console.error(e);
	    }
	     */
	
	    _cookieconsentController2.default.initialize();
	  };
	
	  Shared.isOutdated = function () {
	    return !Modernizr.filereader;
	  };
	
	  Shared.getUserData = function () {
	    if (_utils2.default.isNullOrEmpty(_storageController2.default.getFromSession("data-user")) || _utils2.default.isNullOrEmpty(_storageController2.default.getFromSession("data-user")).data || _utils2.default.isUndefined(_storageController2.default.getFromSession("data-user")).data) {
	      if ($("#logged-in-user-data")[0]) {
	        var userData = JSON.parse(decodeURIComponent($("#logged-in-user-data").attr("data-user")));
	        _storageController2.default.saveToSession("data-user", userData);
	        return userData;
	      }
	    } else {
	      if (_utils2.default.isNotNull(_storageController2.default.getFromSession("data-user"))) {
	        return JSON.parse(_storageController2.default.getFromSession("data-user"));
	      }
	    }
	
	    return null;
	  };
	
	  Shared.updateUserData = function (data) {
	    _storageController2.default.saveToSession("data-user", data);
	  };
	
	  Shared.isLoggedIn = function () {
	    return _utils2.default.isNotNull(Shared.getUserData());
	  };
	
	  function setUpFragmentImages() {
	    /*
	    let headerLogo = require("Images/header/circonopoly-logo.png");
	    // let footerLogo = require("Images/footer/cartamundi-logo.png");
	     $("#header-brand").append("<img src='" + headerLogo + "' alt='Circonopoly'/>");
	    // $("#footer-main-logo").append("<img src='" + footerLogo + "'/>");
	    */
	  }
	
	  function setUpMatchMedia() {
	    // Matches the favicon to the current preferred color scheme
	
	    if (!_utils2.default.isFunction(window.matchMedia)) {
	      return;
	    }
	
	    var faviconDarkLink = document.createElement("link");
	    faviconDarkLink.setAttribute("rel", "favicon icon");
	    faviconDarkLink.setAttribute("type", "image/png");
	    faviconDarkLink.setAttribute("media", "(prefers-color-scheme:dark)");
	    faviconDarkLink.setAttribute("href", faviconDark);
	    document.head.appendChild(faviconDarkLink);
	
	    var links = collectLinks();
	
	    var current = document.createElement("link");
	    current.setAttribute("rel", "shortcut icon");
	    document.head.appendChild(current);
	
	    function faviconApplyLoop() {
	      links.forEach(function (link) {
	        if (window.matchMedia(link.media).matches) {
	          current.setAttribute("type", link.getAttribute("type"));
	          current.setAttribute("href", link.getAttribute("href"));
	        }
	      });
	    }
	
	    faviconApplyLoop();
	    links.forEach(function (link) {
	      document.head.removeChild(link);
	    });
	
	    var lightMediaMatch = window.matchMedia("(prefers-color-scheme:light)");
	    var darkMediaMatch = window.matchMedia("(prefers-color-scheme:dark)");
	
	    if (_utils2.default.isFunction(lightMediaMatch.addEventListener)) {
	      /*
	        This is basically an alias for EventTarget.addEventListener(), for backwards compatibility purposes.
	        Older browsers should use addListener instead of addEventListener since MediaQueryList only inherits from EventTarget in newer browsers.
	      */
	
	      lightMediaMatch.addEventListener("change", function (e) {
	        if (!e.matches) return;
	        faviconApplyLoop();
	      });
	
	      darkMediaMatch.addEventListener("change", function (e) {
	        if (!e.matches) return;
	        faviconApplyLoop();
	      });
	    } else {
	      // noinspection JSDeprecatedSymbols
	      lightMediaMatch.addListener(function (e) {
	        if (!e.matches) return;
	        faviconApplyLoop();
	      });
	
	      // noinspection JSDeprecatedSymbols
	      darkMediaMatch.addListener(function (e) {
	        if (!e.matches) return;
	        faviconApplyLoop();
	      });
	    }
	  }
	
	  function collectLinks() {
	    return Array.prototype.slice.apply(document.head.querySelectorAll("link[rel*='icon']"));
	  }
	
	  //#region Materials and categories
	  Shared.getAllMaterials = function () {
	    return new _es6Promise.Promise(function (resolve, reject) {
	
	      if (_storageController2.default.getFromSession("materials") === null) {
	        _materialService2.default.getAllMaterials().then(function (missionMaterials) {
	          _storageController2.default.saveToSession("materials", missionMaterials);
	          resolve(missionMaterials);
	        }).catch(function (appError) {
	          Error(appError);
	          log.error("could not get materials");
	        });
	      } else {
	        var materials = JSON.parse(_storageController2.default.getFromSession("materials"));
	        if (_utils2.default.isNullOrEmpty(materials) || _utils2.default.isUndefined(materials)) {
	          _materialService2.default.getAllMaterials().then(function (missionMaterials) {
	            _storageController2.default.saveToSession("materials", missionMaterials);
	            resolve(missionMaterials);
	          }).catch(function (appError) {
	            Error(appError);
	            log.error("could not get materials");
	          });
	        } else {
	          resolve(materials);
	        }
	      }
	    });
	  };
	
	  Shared.getAllMaterialCategories = function () {
	    return new _es6Promise.Promise(function (resolve, reject) {
	
	      if (_storageController2.default.getFromSession("material-categories") === null) {
	        _materialService2.default.getAllMaterialCategories().then(function (materialCategories) {
	          _storageController2.default.saveToSession("material-categories", materialCategories);
	          resolve(materialCategories);
	        }).catch(function (appError) {
	          Error(appError);
	          log.error("could not get categories");
	        });
	      } else {
	        var categories = JSON.parse(_storageController2.default.getFromSession("material-categories"));
	        if (_utils2.default.isNullOrEmpty(categories) || _utils2.default.isUndefined(categories)) {
	          _materialService2.default.getAllMaterialCategories().then(function (materialCategories) {
	            _storageController2.default.saveToSession("material-categories", materialCategories);
	            resolve(materialCategories);
	          }).catch(function (appError) {
	            Error(appError);
	            log.error("could not get categories");
	          });
	        } else {
	          resolve(categories);
	        }
	      }
	    });
	  };
	  //#endregion
	
	  //#region Curriculum objectives
	  Shared.getAllObjectives = function () {
	
	    return new _es6Promise.Promise(function (resolve, reject) {
	
	      if (_storageController2.default.getFromSession("objectives") === null) {
	        _curriculumObjectiveService2.default.getAllCurriculumObjectives().then(function (objectives) {
	          _storageController2.default.saveToSession("objectives", objectives);
	          resolve(objectives);
	        }).catch(function (appError) {
	          Error(appError);
	          log.error("could not get objectives");
	        });
	      } else {
	        var objectives = JSON.parse(_storageController2.default.getFromSession("objectives"));
	        if (_utils2.default.isNullOrEmpty(objectives) || _utils2.default.isUndefined(objectives)) {
	          _curriculumObjectiveService2.default.getAllCurriculumObjectives().then(function (objectives) {
	            _storageController2.default.saveToSession("objectives", objectives);
	            resolve(objectives);
	          }).catch(function (appError) {
	            Error(appError);
	            log.error("could not get objectives");
	          });
	        } else {
	          resolve(objectives);
	        }
	      }
	    });
	  };
	
	  Shared.getAllObjectiveCategories = function () {
	    /*
	    //Temporary fake
	    return new Promise(function(resolve, reject) {
	      resolve([
	        {key: "abcd", localizationKey: "objective_category_technology", name:"Technologie"},
	        {key: "efgh", localizationKey: "objective_category_collaboration", name:"Samenwerken"}
	        ]);
	    });
	      */
	
	    return new _es6Promise.Promise(function (resolve, reject) {
	
	      if (_storageController2.default.getFromSession("objective-categories") === null) {
	        _curriculumObjectiveService2.default.getAllCurriculumCategories().then(function (objectiveCategories) {
	          _storageController2.default.saveToSession("objective-categories", objectiveCategories);
	          resolve(objectiveCategories);
	        }).catch(function (appError) {
	          Error(appError);
	          log.error("could not get categories");
	        });
	      } else {
	        var categories = JSON.parse(_storageController2.default.getFromSession("objective-categories"));
	        if (_utils2.default.isNullOrEmpty(categories) || _utils2.default.isUndefined(categories)) {
	          _curriculumObjectiveService2.default.getAllCurriculumCategories().then(function (objectiveCategories) {
	            _storageController2.default.saveToSession("objective-categories", objectiveCategories);
	            resolve(objectiveCategories);
	          }).catch(function (appError) {
	            Error(appError);
	            log.error("could not get categories");
	          });
	        } else {
	          resolve(categories);
	        }
	      }
	    });
	  };
	  //#endregion
	
	  //#region Avatars
	  Shared.getAllAvatars = function () {
	    return new _es6Promise.Promise(function (resolve, reject) {
	
	      if (_storageController2.default.getFromSession("avatars") === null) {
	        _mediaAssetService2.default.getAvatars().then(function (avatars) {
	          _storageController2.default.saveToSession("avatars", avatars);
	          resolve(avatars);
	        }).catch(function (appError) {
	          Error(appError);
	          log.error("could not get avatars");
	        });
	      } else {
	        var avatars = JSON.parse(_storageController2.default.getFromSession("avatars"));
	
	        if (_utils2.default.isNullOrEmpty(avatars) || _utils2.default.isUndefined(avatars)) {
	          _mediaAssetService2.default.getAvatars().then(function (avatars) {
	            _storageController2.default.saveToSession("avatars", avatars);
	            resolve(avatars);
	          }).catch(function (appError) {
	            Error(appError);
	            log.error("could not get avatars");
	          });
	        } else {
	          resolve(avatars);
	        }
	      }
	    });
	  };
	
	  //#endregion
	
	  //#region Session Thumbs
	
	  Shared.getAllSessionThumbs = function () {
	
	    return new _es6Promise.Promise(function (resolve, reject) {
	
	      if (_storageController2.default.getFromSession("session_thumbs") === null) {
	        _mediaAssetService2.default.getThumbs().then(function (thumbs) {
	          _storageController2.default.saveToSession("session_thumbs", thumbs);
	          resolve(thumbs);
	        }).catch(function (appError) {
	          Error(appError);
	          log.error("could not get thumbs");
	        });
	      } else {
	        var thumbs = JSON.parse(_storageController2.default.getFromSession("session_thumbs"));
	        if (_utils2.default.isNullOrEmpty(thumbs) || _utils2.default.isUndefined(thumbs)) {
	          _mediaAssetService2.default.getThumbs().then(function (thumbs) {
	            _storageController2.default.saveToSession("session_thumbs", thumbs);
	            resolve(thumbs);
	          }).catch(function (appError) {
	            Error(appError);
	            log.error("could not get thumbs");
	          });
	        } else {
	          resolve(thumbs);
	        }
	      }
	    });
	  };
	
	  Shared.setupGameboardCodeInput = function (selector) {
	    var input = $(selector);
	
	    input.attr("placeholder", "XXXX-XXXX-XXXX");
	    input.attr("maxlength", "14");
	
	    input.on("keyup", function (e) {
	      // Don't do anything if the user presses backspace (8) or delete (46)
	      var key = e.keyCode || e.charCode;
	      if (key === 8 || key === 46) {
	        return;
	      }
	
	      // Remove all "-" from the string and insert them again in the correct positions
	
	      var text = $(this).val().replace(/\-/g, "");
	
	      if (text.length >= 4) {
	        text = text.substring(0, 4) + "-" + text.substring(4);
	      }
	
	      if (text.length >= 9) {
	        text = text.substring(0, 9) + "-" + text.substring(9);
	      }
	
	      $(this).val(text.toUpperCase());
	    });
	  };
	
	  //#endregion
	
	  Shared.Dialog = _modal2.default;
	
	  return Shared;
	})(Shared);
	
	module.exports = Shared;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _jsCookie = __webpack_require__(686);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 13/01/2017.
	 */
	var utils = __webpack_require__(2);
	var log = __webpack_require__(4)();
	
	
	var storageController = {};
	
	(function (StorageController) {
	  StorageController.keys = {
	    LOGGED_IN_USER: "logged_in_user",
	    ORDER: "order",
	    ACTIVE_CARD_GAME: "active_card_game",
	    DATA_USER: "data-user",
	    MISSIONS: "missions",
	    MATERIALS: "materials",
	    MATERIAL_CATEGORIES: "material-categories",
	    LABELS: "labels",
	    USER_SCHOOLS: "user-schools",
	    OBJECTIVES: "objectives",
	    OBJECTIVE_CATEGORIES: "objective-categories",
	    AVATARS: "avatars",
	    THUMBS: "session_thumbs",
	    COOKIEPOLIYCY_ANALYTICS_CONSENT: "cookiepolicy_analytics_consent"
	  };
	
	  function shouldEncode(key) {
	    // Basically obfuscates the data from these keys
	    return $.inArray(key, [StorageController.keys.LOGGED_IN_USER, StorageController.keys.ORDER]) !== -1;
	  }
	
	  StorageController.clearAll = function () {
	    StorageController.clearSession();
	    StorageController.clearLocal();
	
	    //console.log("cleared everything");
	    //console.log(StorageController.getFromSession("data-user"));
	  };
	
	  StorageController.clearSession = function () {
	    sessionStorage.clear();
	  };
	
	  StorageController.clearLocal = function () {
	    localStorage.clear();
	  };
	
	  StorageController.removeFromSession = function (key) {
	    StorageController.saveToSession(key);
	  };
	
	  StorageController.saveToSession = function (key, obj) {
	    if (storageKeyIsValid(key)) {
	      // if obj is null then remove
	      if (utils.isUndefined(obj)) {
	        sessionStorage.removeItem(key);
	      } else {
	        if (utils.isObject(obj)) {
	          if (utils.isFunction(obj.getSerializable)) {
	            obj = obj.getSerializable();
	          }
	
	          obj = utils.stringifyJSON(obj);
	        }
	
	        if (shouldEncode(key)) {
	          obj = utils.btoa(obj);
	        }
	
	        sessionStorage.setItem(key, obj);
	      }
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	  };
	
	  StorageController.getFromSession = function (key, json) {
	    if (storageKeyIsValid(key)) {
	      var tmpValue = sessionStorage.getItem(key);
	
	      if (shouldEncode(key)) {
	        try {
	          tmpValue = utils.atob(tmpValue);
	        } catch (e) {
	          log.error("Failed to decode value '%s'", tmpValue);
	        }
	      }
	
	      if (json) {
	        return utils.parseJSON(tmpValue, true);
	      }
	
	      return tmpValue;
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	
	    return null;
	  };
	
	  StorageController.removeFromLocal = function (key) {
	    StorageController.saveToLocal(key);
	  };
	
	  StorageController.saveToLocal = function (key, obj) {
	    if (storageKeyIsValid(key)) {
	      if (utils.isUndefined(obj)) {
	        localStorage.removeItem(key);
	      } else {
	        if (utils.isObject(obj)) {
	          if (utils.isFunction(obj.getSerializable)) {
	            obj = obj.getSerializable();
	          }
	
	          obj = utils.stringifyJSON(obj);
	        }
	
	        if (shouldEncode(key)) {
	          obj = utils.btoa(obj);
	        }
	
	        localStorage.setItem(key, obj);
	      }
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	  };
	
	  StorageController.getFromLocal = function (key, json) {
	    if (storageKeyIsValid(key)) {
	      var tmpValue = localStorage.getItem(key);
	
	      if (shouldEncode(key)) {
	        try {
	          tmpValue = utils.atob(tmpValue);
	        } catch (e) {
	          log.error("Failed to decode value '%s'", tmpValue);
	        }
	      }
	
	      if (json) {
	        return utils.parseJSON(tmpValue, true);
	      }
	
	      return tmpValue;
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	
	    return null;
	  };
	
	  StorageController.saveCookie = function (name, value, daysUntilExpire) {
	    var options = {};
	    if (utils.isNumber(daysUntilExpire)) {
	      options.expires = daysUntilExpire;
	    }
	
	    _jsCookie2.default.set(name, value, { expires: daysUntilExpire });
	  };
	
	  StorageController.getCookie = function (name) {
	    return _jsCookie2.default.get(name);
	  };
	
	  StorageController.removeCookie = function (name) {
	    _jsCookie2.default.remove(name);
	  };
	
	  function storageKeyIsValid(key) {
	    for (var objKey in StorageController.keys) {
	      if (StorageController.keys.hasOwnProperty(objKey) && StorageController.keys[objKey] === key) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	})(storageController);
	
	module.exports = storageController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _navigationUtils = __webpack_require__(147);
	
	var _navigationUtils2 = _interopRequireDefault(_navigationUtils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _historyBar = __webpack_require__(621);
	
	var _historyBar2 = _interopRequireDefault(_historyBar);
	
	__webpack_require__(573);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HistoryBar = function () {
	  function HistoryBar(options) {
	    _classCallCheck(this, HistoryBar);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.historyObject = options.historyObject;
	  }
	
	  _createClass(HistoryBar, [{
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_historyBar2.default);
	      this.$container.append(this.$element);
	      this.updateHistoryBar();
	      _languageManager2.default.applyLocale(this.$element);
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "updateHistoryBar",
	    value: function updateHistoryBar() {
	      var _this = this;
	
	      if (_utils2.default.isNotNull(this.$element)) {
	        this.historyObject.forEach(function (page) {
	          var element = $("<a class='small-grey-text' href='" + page.location + "'><span>\t&gt;</span><span data-localize='" + page.name + "'></span></a>");
	          _this.$element.append(element);
	        });
	      }
	    }
	  }, {
	    key: "historyObject",
	    get: function get() {
	      return this._historyObject;
	    },
	    set: function set(historyObject) {
	      this._historyObject = historyObject;
	      this.updateHistoryBar();
	    }
	  }], [{
	    key: "setUpHistoryBar",
	    value: function setUpHistoryBar(options) {
	      var instance = new HistoryBar(options);
	      instance.render();
	      return instance;
	    }
	  }]);
	
	  return HistoryBar;
	}();
	
	exports.default = HistoryBar;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2020-02-07 (12:11).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _navigationUtils = __webpack_require__(147);
	
	var _navigationUtils2 = _interopRequireDefault(_navigationUtils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _sidenav = __webpack_require__(646);
	
	var _sidenav2 = _interopRequireDefault(_sidenav);
	
	var _shared = __webpack_require__(8);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	__webpack_require__(581);
	
	var _es6Promise = __webpack_require__(45);
	
	var _schoolService = __webpack_require__(58);
	
	var _schoolService2 = _interopRequireDefault(_schoolService);
	
	var _storageController = __webpack_require__(21);
	
	var _storageController2 = _interopRequireDefault(_storageController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SideNav = function () {
	  function SideNav(options) {
	    _classCallCheck(this, SideNav);
	
	    this.$container = $(options.container);
	    this.onNavClicked = options.onNavClicked;
	    this.hasRendered = false;
	    this.profile = _shared2.default.getUserData();
	    this.avatarUrl = null;
	  }
	
	  _createClass(SideNav, [{
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	
	      this.$element = $(_sidenav2.default);
	      this.$container.append(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	
	      this.updateProfile();
	
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "enableMainNav",
	    value: function enableMainNav() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.find(".sidenav__main .nav-link").removeClass("disabled");
	      }
	    }
	  }, {
	    key: "disableMainNav",
	    value: function disableMainNav() {
	      // TODO - remove
	      if (false) return;
	
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.find(".sidenav__main .nav-link").addClass("disabled");
	      }
	    }
	
	    //#region schools
	
	  }, {
	    key: "resetSchools",
	    value: function resetSchools() {
	      var _this = this;
	
	      this.getSchools().then(function (schools) {
	        _this.assignSchools(schools);
	      });
	    }
	  }, {
	    key: "getSchools",
	    value: function getSchools() {
	      return new _es6Promise.Promise(function (resolve, reject) {
	        if (_storageController2.default.getFromSession("user-schools") === null) {
	          _schoolService2.default.getSchools().then(function (schools) {
	            _storageController2.default.saveToSession("user-schools", schools);
	            resolve(schools);
	          }).catch(function (appError) {
	            Error(appError);
	            log.error("could not get schools");
	          });
	        } else {
	          var schools = JSON.parse(_storageController2.default.getFromSession("user-schools"));
	          resolve(schools);
	        }
	      });
	    }
	  }, {
	    key: "assignSchools",
	    value: function assignSchools(schools) {
	      this.profile.linkedSchools = schools;
	      this.updateProfile();
	    }
	    //#endregion
	
	  }, {
	    key: "resetAvatar",
	    value: function resetAvatar() {
	      var _this2 = this;
	
	      if (this.profile.profilePicture && this.profile.profilePicture.url) {
	        this.avatarUrl = this.profile.profilePicture.url;
	      } else {
	        _shared2.default.getAllAvatars().then(function (allAvatars) {
	          if (allAvatars.find(function (avatar) {
	            return avatar.key === _this2.profile.avatar.key;
	          })) {
	            _this2.avatarUrl = allAvatars.find(function (avatar) {
	              return avatar.key === _this2.profile.avatar.key;
	            }).url;
	            _this2.updateProfile();
	          } else {
	            _this2.avatarUrl = null;
	            console.log("avatar not found/set");
	          }
	        });
	      }
	      this.updateProfile();
	    }
	  }, {
	    key: "setUser",
	    value: function setUser() {
	      this.profile = _shared2.default.getUserData();
	      this.resetSchools();
	      this.resetAvatar();
	      this.updateProfile();
	    }
	  }, {
	    key: "updateProfile",
	    value: function updateProfile() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var $profileImage = this.$element.find("[data-bind-target='profile-image']");
	        $profileImage.empty();
	
	        if (_utils2.default.isNotNull(this.profile) && _utils2.default.isNotNull(this.avatarUrl)) {
	          $profileImage.append("<img src=" + this.avatarUrl + " alt=\"" + _languageManager2.default.getValueForKey("sidebar.profile.image_alt") + "\" />");
	        } else {
	          var imageUrl = __webpack_require__(141);
	          $profileImage.append("<img src=" + imageUrl + " alt=\"" + _languageManager2.default.getValueForKey("sidebar.profile.image_alt") + "\" draggable=\"false\" />");
	        }
	
	        var $profileName = this.$element.find("[data-bind-target='profile-full-name']");
	        $profileName.empty();
	
	        if (_utils2.default.isNotNull(this.profile) && _utils2.default.isNotNull(this.profile.data)) {
	          $profileName.text(this.profile.data.firstname + " " + this.profile.data.lastname);
	        }
	
	        var $profileSchools = this.$element.find("[data-bind-target='profile-linked-schools']");
	        $profileSchools.empty();
	
	        if (_utils2.default.isNotNull(this.profile) && _utils2.default.isNotNull(this.profile.linkedSchools) && this.profile.linkedSchools.length > 0) {
	          for (var i = 0; i < this.profile.linkedSchools.length; i++) {
	            $profileSchools.append("<li>" + this.profile.linkedSchools[i].name + "</li>");
	          }
	        } else {
	          $profileSchools.append("<li>" + _languageManager2.default.getValueForKey("sidebar.profile.linked_schools.empty") + "</li>");
	        }
	      }
	    }
	  }, {
	    key: "profile",
	    get: function get() {
	      return this._profile;
	    },
	    set: function set(profile) {
	      this._profile = profile;
	      this.updateProfile();
	    }
	  }], [{
	    key: "setUpSideNav",
	    value: function setUpSideNav(options) {
	      var instance = new SideNav(options);
	      instance.render();
	      instance.resetSchools();
	      instance.resetAvatar();
	      // Reset nav highlight after sidenav has been rendered
	      _navigationUtils2.default.setNavHighlight();
	      return instance;
	    }
	  }]);
	
	  return SideNav;
	}();
	
	exports.default = SideNav;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 19/07/2017.
	 */
	var utils = __webpack_require__(2);
	var request = __webpack_require__(29);
	
	var UserServices = {};
	
	(function (UserServices) {
	  UserServices.getAuthenticatedUserData = function () {
	    // TODO fetch authenticated user profile (via header-meta hidden input??)
	
	    var tmpProfile = {
	      imageUrl: "./assets/images/avatars/avatar_default.png",
	      fullName: "Clara Vlaeminck",
	      linkedSchools: []
	    };
	
	    return new Promise(function (resolve, reject) {
	      if (false) {
	        reject("brol");
	      } else {
	        resolve(tmpProfile);
	      }
	    });
	  };
	
	  UserServices.getUser = function () {
	    return request.get({
	      url: "/user",
	      cache: false
	    });
	  };
	
	  UserServices.getLoggedInUser = function () {
	    return request.get({
	      url: "/services/users/loggedin",
	      cache: false
	    });
	  };
	
	  UserServices.logout = function () {
	    return request.get({
	      url: "/logout",
	      cache: false
	    });
	  };
	
	  UserServices.deleteProfile = function () {
	    return request.delete({
	      url: utils.getServiceUrl("/users/delete_profile"),
	      cache: false
	    });
	  };
	
	  UserServices.authenticateUser = function (username, password) {
	    // AuthenticateUserServlet functions as a proxy for /access/authenticate/password so we can force logout when a new authentication is requested
	    return request.post({
	      // url: "/access/authenticate/password",
	      url: "/authenticate-user",
	      cache: false,
	      dataType: request.DATA_TYPES.TEXT,
	      contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
	      data: {
	        username: utils.isDefined(username) ? username : null,
	        password: utils.isDefined(password) ? password : null
	      }
	    });
	  };
	
	  UserServices.requestPasswordReset = function (username) {
	    return request.post({
	      url: utils.getServiceUrl("/users/reset-password"),
	      cache: false,
	      // contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
	      data: {
	        username: username
	      }
	    }).then(UserServices.onServiceComplete);
	  };
	
	  UserServices.changePassword = function (data) {
	    return request.post({
	      url: utils.getServiceUrl("/users/change-password"),
	      cache: false,
	      data: {
	        username: data.username,
	        "password-old": data.passwordOld,
	        "password-new": data.passwordNew,
	        ticket: data.ticket
	      }
	    }).then(UserServices.onServiceComplete);
	  };
	
	  UserServices.getKeyForEmail = function (email) {
	    return request.post({
	      url: utils.getServiceUrl("/users/email"),
	      cache: false,
	      data: {
	        email: email
	      }
	    }).then(UserServices.onServiceComplete);
	  };
	
	  UserServices.getUser = function (key) {
	    return request.get({
	      url: utils.getServiceUrl("/users/" + key),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    }).then(UserServices.onServiceComplete);
	  };
	
	  UserServices.registerUser = function (userObj) {
	    return request.post({
	      url: utils.getServiceUrl("/users/register"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
	      data: {
	        username: userObj.username,
	        password: userObj.password,
	        firstname: userObj.firstname,
	        lastname: userObj.lastname,
	        gameboardCode: userObj.gameboardCode
	      }
	    }).then(UserServices.onServiceComplete);
	  };
	
	  UserServices.updateUserProfile = function (firstname, lastname) {
	    return request.post({
	      url: utils.getServiceUrl("/users/update_profile"),
	      cache: false,
	      data: {
	        firstname: firstname,
	        lastname: lastname
	      }
	    }).then(UserServices.onServiceComplete);
	  };
	
	  UserServices.setAvatar = function (avatarKey) {
	    return request.post({
	      url: utils.getServiceUrl("/users/set_avatar"),
	      cache: false,
	      data: {
	        avatar_key: avatarKey
	      }
	    }).then(UserServices.onServiceComplete);
	  };
	
	  UserServices.linkGameboard = function (email, code) {
	    return request.post({
	      url: utils.getServiceUrl("/users/link_gameboard"),
	      cache: false,
	      data: {
	        email: email,
	        gameboard_code: code
	      }
	    }).then(UserServices.onServiceComplete);
	  };
	
	  UserServices.unlinkGameboard = function () {
	    return request.post({
	      url: utils.getServiceUrl("/users/unlink_gameboard"),
	      cache: false
	    }).then(UserServices.onServiceComplete);
	  };
	
	  UserServices.changeGameboard = function (code) {
	    return request.post({
	      url: utils.getServiceUrl("/users/replace_gameboard"),
	      cache: false,
	      data: {
	        gameboard_code: code
	      }
	    }).then(UserServices.onServiceComplete);
	  };
	
	  UserServices.onServiceComplete = function (data) {
	    if (utils.isNotNull(data) && data.result === "success" && data.data) {
	      return data.data;
	    }
	
	    return null;
	  };
	})(UserServices);
	
	module.exports = UserServices;

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 16/01/2017.
	 */
	var utils = __webpack_require__(2);
	var log = __webpack_require__(4)();
	var AppError = __webpack_require__(213);
	
	var request = {};
	
	(function (Request) {
	  Request.CONTENT_TYPES = {
	    APPLICATION_FORM_URLENCODED: "application/x-www-form-urlencoded",
	    TEXT_PLAIN: "text/plain",
	    APPLICATION_JSON: "application/json",
	    MULTIPART_FORM_DATA: "multipart/form-data"
	  };
	
	  Request.DATA_TYPES = {
	    TEXT: "text",
	    JSON: "json",
	    XML: "xml"
	  };
	
	  Request.get = function (options) {
	    options.type = "GET";
	    return doRequest(options);
	  };
	
	  Request.post = function (options) {
	    options.type = "POST";
	    return doRequest(options);
	  };
	
	  Request.put = function (options) {
	    options.type = "PUT";
	    return doRequest(options);
	  };
	
	  Request.delete = function (options) {
	    options.type = "DELETE";
	    return doRequest(options);
	  };
	
	  function doRequest(options) {
	    var startTime = Date.now();
	    logRequestInfo(startTime, options);
	
	    // Download / Upload progress
	    if (utils.isFunction(options.onProgress) || utils.isFunction(options.onUploadProgress)) {
	      options.xhr = function () {
	        var xhr = new window.XMLHttpRequest();
	
	        if (utils.isFunction(options.onUploadProgress)) {
	          xhr.upload.addEventListener("progress", function (evt) {
	            if (evt.lengthComputable) {
	              var percentComplete = evt.loaded / evt.total;
	              options.onUploadProgress(percentComplete);
	            }
	          }, false);
	        }
	
	        if (utils.isFunction(options.onProgress)) {
	          xhr.addEventListener("progress", function (evt) {
	            if (evt.lengthComputable) {
	              var percentComplete = evt.loaded / evt.total;
	              options.onProgress(percentComplete);
	            }
	          }, false);
	        }
	
	        return xhr;
	      };
	    }
	
	    if (options.type !== "GET" && options.contentType === Request.CONTENT_TYPES.APPLICATION_JSON && (utils.isObject(options.data) || utils.isArray(options.data))) {
	      options.data = utils.stringifyJSON(options.data);
	    }
	
	    return new Promise(function (resolve, reject) {
	      // Request (order matters! in this case: always -> done / fail)
	      $.ajax(options).always(function (data, textStatus) {
	        logRequestComplete(startTime, options, textStatus, data);
	      }).done(function (data) {
	        if (utils.isNotNull(data) && data.hasOwnProperty("responseJSON") && data.responseJSON.result === "error") {
	          dataToError(data, reject);
	          return;
	        }
	
	        resolve(data);
	      }).fail(function (data) {
	        dataToError(data, reject);
	      });
	    });
	  }
	
	  function logRequestInfo(startTime, requestOptions) {
	    var startColor = "#5076ff";
	    var headerCss = utils.format("background-color: #222;color: {0};border-top: 1px solid {1};", startColor, startColor);
	    var footerCss = utils.format("border-bottom: 1px solid {0}", startColor);
	    log.info("%cRequest started%c\nUrl: %s\nMethod: %s\nContent-type: %s\nDataType: %s\n%cData: %o%c", headerCss, "", requestOptions.url, requestOptions.type, requestOptions.contentType, requestOptions.dataType, footerCss, requestOptions.data, "");
	  }
	
	  function logRequestComplete(startTime, requestOptions, textStatus, result) {
	    if (false) {
	      var executeTime = Date.now() - startTime;
	      executeTime = executeTime / 1000 + "s";
	
	      var completeColor = "#bada55";
	      var headerCss = utils.format("background-color: #222;color: {0};border-top: 1px solid {1};", completeColor, completeColor);
	      var footerCss = utils.format("border-bottom: 1px solid {0}", completeColor);
	
	      log.info("%cRequest complete%c\nUrl: %s\nMethod: %s\nStatus: %s\nExecute time: %s\n%cResult: %o%c",
	      /*empty string to reset css*/
	      headerCss, "", requestOptions.url, requestOptions.type, textStatus, executeTime, footerCss, result, "");
	    }
	  }
	
	  function dataToError(data, callback) {
	    if (utils.isFunction(callback)) {
	      if (utils.isNotNull(data) && data.hasOwnProperty("responseJSON") && utils.isNotNull(data.responseJSON) && data.responseJSON.result === "error") {
	        callback(new AppError({
	          code: data.responseJSON.data.appErrorCode,
	          message: data.responseJSON.data.message,
	          data: data
	        }));
	      } else if (data.status === 401) {
	        callback(new AppError({
	          code: "401",
	          message: data.responseJSON.data,
	          data: data
	        }));
	      } else {
	        callback(new AppError({
	          code: null,
	          message: null,
	          data: data
	        }));
	      }
	    }
	  }
	})(request);
	
	module.exports = request;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 20/07/2017.
	 */
	var utils = __webpack_require__(2);
	var log = __webpack_require__(4)();
	
	module.exports = function () {
	  function FormValidator(options) {
	    _classCallCheck(this, FormValidator);
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.selector = $(options.selector);
	    // Rules either come from javascript in this property or from data attributes
	    // eg. data-fv-required="true" data-fv-min-length="6" data-fv-max-length="30" data-fv-same-as="something"
	    // if both are present then rules from javascript take priority
	    this.rules = options.rules;
	
	    this.errorClassName = utils.isNullOrEmpty(options.errorClassName) ? "is-invalid" : options.errorClassName;
	
	    this.validateOnChange = utils.isBoolean(options.validateOnChange) ? options.validateOnChange : false;
	    this.onValidateElement = options.onValidateElement;
	
	    this.hasChangedValues = false;
	
	    this.init();
	  }
	
	  _createClass(FormValidator, [{
	    key: "init",
	    value: function init() {
	      var that = this;
	
	      that.selector.find("input, textarea").on("input", function (e) {
	        $(this).removeClass(that.errorClassName);
	      });
	
	      that.selector.find("select").on("change", function (e) {
	        $(this).removeClass(that.errorClassName);
	      });
	
	      that.selector.find("input, textarea, select").on("change", function (e) {
	        var $el = $(this);
	        var name = $el.data("fv-name") || $el.attr("id");
	
	        var elRules = null;
	
	        if (utils.isNotNull(name) && utils.isNotNull(that.rules) && that.rules.hasOwnProperty(name)) {
	          elRules = that.rules[name];
	        }
	
	        var validateOnChange = that.validateOnChange;
	
	        if (utils.isNotNull(elRules)) {
	          validateOnChange = that.validateOnChange && elRules.validateOnChange !== false || elRules.validateOnChange;
	        }
	
	        if (validateOnChange) {
	          var isValid = FormValidator.validateElement($el, that.errorClassName, elRules);
	
	          if (utils.isFunction(that.onValidateElement)) {
	            that.onValidateElement($el, isValid);
	          }
	        }
	
	        that.hasChangedValues = true;
	      });
	    }
	  }, {
	    key: "clearForm",
	    value: function clearForm() {
	      this.selector.find("input, select, textarea").each(function (index, el) {
	        var $el = $(el);
	        var name = $el.data("fv-name") || $el.attr("id");
	        var tagName = $el.prop("tagName").toLowerCase();
	        var type = tagName === "input" ? $el.attr("type") : tagName;
	
	        if ($el.data("fv-ignore") === true || type === "hidden" || utils.isNullOrEmpty(name)) {
	          return true;
	        }
	
	        $el.val("");
	      });
	    }
	  }, {
	    key: "setValueForKey",
	    value: function setValueForKey(key, value, options) {
	      options = utils.isNotNull(options) ? options : {};
	
	      var $el = this.selector.find("[data-fv-name='" + key + "']");
	
	      if (utils.isNull($el) || !$el.length) {
	        $el = this.selector.find("#" + key);
	      }
	
	      if (utils.isNotNull($el) && $el.length) {
	        var tagName = $el.prop("tagName").toLowerCase();
	        var type = tagName === "input" ? $el.attr("type") : tagName;
	
	        if ($el.length > 0 && utils.isNotNull($el[0].selectize)) {
	          $el[0].selectize.setValue(value, true);
	        } else if (type === "checkbox") {
	          if (value === 0 || typeof value === "undefined" || value === false) {
	            $el.removeAttr("checked");
	          } else {
	            $el.attr("checked", "checked");
	          }
	        } else {
	
	          $el.val(value);
	        }
	
	        if (options.markAsChanged) {
	          this.hasChangedValues = true;
	        }
	
	        if (options.triggerChangeEvent) {
	          $el.trigger("change");
	        }
	
	        return $el;
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      var that = this;
	      var isValid = true;
	
	      this.selector.find("input, textarea, select").each(function (index, el) {
	        var $el = $(el);
	
	        var name = $el.data("fv-name") || $el.attr("id");
	
	        var elRules = null;
	
	        if (utils.isNotNull(name) && utils.isNotNull(that.rules) && that.rules.hasOwnProperty(name)) {
	          elRules = that.rules[name];
	        }
	
	        var formElValid = FormValidator.validateElement($el, that.errorClassName, elRules);
	
	        // log.info("%s is %s for rules %o", name, (formElValid ? "valid" : "not valid"), elRules);
	        if (utils.isFunction(that.onValidateElement)) {
	          that.onValidateElement($el, formElValid);
	        }
	
	        isValid = isValid && formElValid;
	      });
	
	      return isValid;
	    }
	  }, {
	    key: "getFormData",
	    value: function getFormData() {
	      var formData = {};
	
	      this.selector.find("input, select, textarea").each(function (index, el) {
	        var $el = $(el);
	        var name = $el.data("fv-name") || $el.attr("id");
	        var tagName = $el.prop("tagName").toLowerCase();
	        var type = tagName === "input" ? $el.attr("type") : tagName;
	
	        if ($el.data("fv-ignore") === true || type === "hidden") {
	          return true;
	        } else if (type === "checkbox") {
	          formData[name] = $el.is(":checked");
	        } else {
	          formData[name] = $el.val();
	        }
	      });
	
	      return formData;
	    }
	  }], [{
	    key: "validateElement",
	    value: function validateElement(selector, errorClassName, rules) {
	      var $el = $(selector).removeClass(errorClassName);
	      var name = $el.data("fv-name") || $el.attr("id");
	      rules = utils.isNotNull(rules) ? rules : {};
	
	      var isValid = true;
	
	      var tagName = $el.prop("tagName").toLowerCase();
	      var type = tagName === "input" ? $el.attr("type") : tagName;
	      var value = $el.val();
	      var required = utils.isBoolean(rules.required) ? rules.required : $el.data("fv-required") || false;
	      var minLength = utils.isDefined(rules.minLength) ? rules.minLength : $el.data("fv-min-length");
	      var maxLength = utils.isDefined(rules.maxLength) ? rules.maxLength : $el.data("fv-max-length");
	      var minVal = utils.isDefined(rules.minVal) ? rules.minVal : $el.data("fv-min-val");
	      var maxVal = utils.isDefined(rules.maxVal) ? rules.maxVal : $el.data("fv-max-val");
	      var sameAs = utils.isDefined(rules.sameAs) ? rules.sameAs : $el.data("fv-same-as");
	      var validateFunc = rules.validator;
	      var overwriteValidateFunc = rules.overwriteValidator;
	
	      if ($el.data("fv-ignore") === true || type === "hidden") {
	        return isValid;
	      }
	
	      var formElInfo = {
	        tagName: tagName,
	        type: type,
	        value: value,
	        required: required,
	        minLength: minLength,
	        maxLength: maxLength,
	        minVal: minVal,
	        maxVal: maxVal,
	        sameAs: sameAs,
	        validator: validateFunc,
	        overwriteValidator: overwriteValidateFunc
	      };
	
	      log.cssLog("%c%s%c form element info: %o", name, formElInfo, log.infoCss);
	
	      if (utils.isFunction(overwriteValidateFunc)) {
	        if (!overwriteValidateFunc(value)) {
	          log.cssLog("%s is not valid because custom overwrite validator function did not return true for value [%s]", name, value, log.errorCss);
	          isValid = false;
	        }
	      }
	
	      if (utils.isNullOrEmpty(value)) {
	        if (required) {
	          log.cssLog("%s is not valid because the value is required and value is [%s]", name, value, log.errorCss);
	          isValid = false;
	        }
	      } else {
	        if (type === "number") {
	          value = utils.stringToInt(value);
	        }
	
	        if (isValid && type === "number" && !utils.isNumber(value)) {
	          log.cssLog("%s is not valid because type is number and [%s] is not a number", name, value, log.errorCss);
	          isValid = false;
	        }
	
	        if (tagName === "input" || tagName === "textarea") {
	          if (type === "number") {
	            if (isValid && utils.isNumber(minVal)) {
	              if (value < minVal) {
	                log.cssLog("%s is not valid because value [%s] is less than the min-val (%s)", name, value, minVal, log.errorCss);
	                isValid = false;
	              }
	            }
	
	            if (isValid && utils.isNumber(maxVal)) {
	              if (value > maxVal) {
	                log.cssLog("%s is not valid because value [%s] is more than the max-val (%s)", name, value, maxVal, log.errorCss);
	                isValid = false;
	              }
	            }
	          } else {
	            if (isValid && utils.isNumber(minLength)) {
	              if (value.length < minLength) {
	                log.cssLog("%s is not valid because the length [%s] of value [%s] is less than the min-length (%s)", name, value.length, value, minLength, log.errorCss);
	                isValid = false;
	              }
	            }
	
	            if (isValid && utils.isNumber(maxLength)) {
	              if (value.length > maxLength) {
	                log.cssLog("%s is not valid because the length [%s] of value [%s] is greater than the max-length (%s)", name, value.length, value, maxLength, log.errorCss);
	                isValid = false;
	              }
	            }
	          }
	        }
	
	        if (isValid && type === "email" && !utils.isValidEmail(value)) {
	          log.cssLog("%s is not valid because type is email and [%s] is not a valid email", name, value, log.errorCss);
	          isValid = false;
	        }
	
	        if (isValid && utils.isNotNull(sameAs)) {
	          var sameAsEl = $("[data-fv-name='" + sameAs + "']");
	          var sameAsValue;
	
	          if (utils.isNotNull(sameAs) && sameAs.length) {
	            sameAsValue = sameAsEl.val();
	          } else {
	            sameAs = $(sameAs);
	
	            if (utils.isNotNull(sameAs) && sameAs.length) {
	              sameAsValue = sameAsEl.val();
	            }
	          }
	
	          if (value !== sameAsValue) {
	            log.cssLog("%s is not valid because value [%s] is not the same as value [%s] from %s", name, value, sameAsValue, sameAs, log.errorCss);
	            isValid = false;
	          }
	        }
	      }
	
	      if (isValid && utils.isFunction(validateFunc)) {
	        if (!validateFunc(value)) {
	          log.cssLog("%s is not valid because custom validator function did not return true for value [%s]", name, value, log.errorCss);
	          isValid = false;
	        }
	      }
	
	      if (isValid) {
	        log.cssLog("%s is valid with value [%s] for form element %o", name, value, formElInfo, log.successCss);
	      } else {
	        if (!$el.hasClass(errorClassName)) {
	          $el.addClass(errorClassName);
	        }
	      }
	
	      return isValid;
	    }
	  }]);
	
	  return FormValidator;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _request = __webpack_require__(29);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MissionService = {};
	
	(function (MissionService) {
	  MissionService.getMission = function (key) {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/missions/" + key),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(MissionService.onServiceComplete);
	  };
	
	  MissionService.getMissionsForUser = function () {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/missions"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(MissionService.onServiceComplete);
	  };
	
	  MissionService.createMission = function (missionObj) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/missions"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON,
	      data: missionObj
	    }).then(MissionService.onServiceComplete);
	  };
	
	  MissionService.updateMission = function (missionObj) {
	    return _request2.default.put({
	      url: _utils2.default.getServiceUrl("/missions/" + missionObj.key),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON,
	      data: missionObj
	    }).then(MissionService.onServiceComplete);
	  };
	
	  MissionService.deleteMission = function (missionKey) {
	    return _request2.default.delete({
	      url: _utils2.default.getServiceUrl("/missions/" + missionKey),
	      cache: false
	    }).then(MissionService.onServiceComplete);
	  };
	
	  MissionService.copyMission = function (missionKey) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/missions/" + missionKey + "/copy"),
	      cache: false
	    }).then(MissionService.onServiceComplete);
	  };
	
	  MissionService.favoriteMission = function (missionKey) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/missions/" + missionKey + "/favorite"),
	      cache: false
	    }).then(MissionService.onServiceComplete);
	  };
	
	  MissionService.unfavoriteMission = function (missionKey) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/missions/" + missionKey + "/unfavorite"),
	      cache: false
	    }).then(MissionService.onServiceComplete);
	  };
	
	  MissionService.shareWithUser = function (missionKey, userKey) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/missions/" + missionKey + "/share/user"),
	      cache: false,
	      data: {
	        "user-key": userKey
	      }
	    }).then(MissionService.onServiceComplete);
	  };
	
	  MissionService.shareWithSchool = function (missionKey, schoolKey) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/missions/" + missionKey + "/share/school"),
	      cache: false,
	      data: {
	        "school-key": schoolKey
	      }
	    }).then(MissionService.onServiceComplete);
	  };
	
	  MissionService.unshareWithUser = function (missionKey, userKey) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/missions/" + missionKey + "/unshare/user"),
	      cache: false,
	      data: {
	        "user-key": userKey
	      }
	    }).then(MissionService.onServiceComplete);
	  };
	
	  MissionService.unshareWithSchool = function (missionKey, schoolKey) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/missions/" + missionKey + "/unshare/school"),
	      cache: false,
	      data: {
	        "school-key": schoolKey
	      }
	    }).then(MissionService.onServiceComplete);
	  };
	
	  MissionService.onServiceComplete = function (data) {
	    if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	      return data.data;
	    }
	
	    return null;
	  };
	})(MissionService);
	
	module.exports = MissionService;

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	  DEFAULT_LOCALE: "nl-BE",
	
	  API_DATE_FORMAT: "YYYY-MM-DDTHH:mm:ss.SSSZZ",
	  READABLE_DATE_FORMAT: "DD-MM-YYYY",
	
	  // 50mb
	  // MAX_UPLOAD_FILE_SIZE: 52428800,
	  // 100mb
	  // MAX_UPLOAD_FILE_SIZE: 104857600,
	  // 250mb
	  MAX_UPLOAD_FILE_SIZE: 262144000,
	
	  WEBSOCKET_URL: (window.location.protocol === "https:" ? "wss" : "ws") + "://" + window.location.host + "/services/1.0/realtime",
	  //WEBSOCKET_URL: "ws://localhost:8080/services/1.0/realtime",
	  // WEBSOCKET_URL: "ws://10.4.2.16:8080/services/1.0/realtime",
	  // WEBSOCKET_URL: "wss://hedgehog.cartamundi-digital.com/services/1.0/realtime",
	
	
	  APP_ERROR_USER_NOT_LINKED_TO_GAMEBOARD: "E48579",
	  USER_EMAIL_INVALID: "E73541",
	  USER_NOT_AUTHENTICATED: "E45557",
	  USER_NOT_FOUND: "E91489",
	  USER_DUPLICATE_EMAIL: "E12319",
	  PASSWORD_INCORRECT: "E73550",
	  PASSWORD_FORMAT_INVALID: "E84597",
	  GAMEBOARD_NOT_FOUND: "E66821",
	  GAMEBOARD_MAX_USERS_REACHED: "E75931",
	
	  WEBSOCKET_SERVICES: {
	    START_SESSION: "start_session",
	    PAUSE_SESSION: "pause_session",
	    FINISH_SESSION: "finish_session",
	    JOIN_SESSION: "join_session",
	    SELECT_SESSION_GROUP: "select_session_group",
	    UNSELECT_SESSION_GROUP: "unselect_session_group",
	    SET_SESSION_GROUP_CHARACTER: "set_session_group_character",
	    MOVE_CHARACTER: "move_character",
	    PICKUP_MATERIAL: "pickup_material",
	    DROP_MATERIAL: "drop_material"
	  },
	
	  WEBSOCKET_MESSAGES: {
	    CHARACTER_SELECTED: "character_selected",
	    CHARACTER_MOVED: "character_moved",
	    SESSION_MATERIAL_PICKED_UP: "session_material_picked_up",
	    SESSION_MATERIAL_DROPPED: "session_material_dropped",
	    TURN_STARTED: "message_turn_started",
	    TURN_ENDED: "message_turn_ended"
	  },
	
	  CHARACTER_ROTATIONS: {
	    NORTH: 1,
	    EAST: 2,
	    SOUTH: 4,
	    WEST: 8
	  }
	};

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _request = __webpack_require__(29);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SchoolService = {};
	
	(function (SchoolService) {
	  SchoolService.getSchools = function () {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/schools"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(SchoolService.onServiceComplete);
	  };
	
	  SchoolService.getSchoolsForZip = function (zip) {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/schools/zip/" + zip),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(SchoolService.onServiceComplete);
	  };
	
	  SchoolService.requestToAddSchool = function (schoolNumber, schoolName, schoolAddress) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/schools/request_to_add"),
	      cache: false,
	      data: {
	        "school-number": schoolNumber,
	        "school-name": schoolName,
	        "school-address": schoolAddress
	      }
	    }).then(SchoolService.onServiceComplete);
	  };
	
	  SchoolService.linkUser = function (schoolKey) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/schools/" + schoolKey + "/link"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON
	    }).then(SchoolService.onServiceComplete);
	  };
	
	  SchoolService.unlinkUser = function (schoolKey) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/schools/" + schoolKey + "/unlink"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON
	    }).then(SchoolService.onServiceComplete);
	  };
	
	  SchoolService.onServiceComplete = function (data) {
	    if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	      return data.data;
	    }
	
	    return null;
	  };
	})(SchoolService);
	
	module.exports = SchoolService;

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _request = __webpack_require__(29);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SessionService = {};
	
	(function (SessionService) {
	  SessionService.getSessionsForUser = function () {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/sessions"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(SessionService.onServiceComplete);
	  };
	
	  SessionService.isStarted = function (key) {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/sessions/" + key + "/is_started"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(SessionService.onServiceComplete);
	  };
	
	  SessionService.getStatus = function (key) {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/sessions/" + key + "/status"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(SessionService.onServiceComplete);
	  };
	
	  SessionService.getMaterialsForSession = function (key) {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/sessions/" + key + "/materials"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(SessionService.onServiceComplete);
	  };
	
	  SessionService.generatePdf = function (key) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/sessions/" + key + "/pdf"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(SessionService.onServiceComplete);
	  };
	
	  SessionService.startSession = function (key, showWizard, materialsForSessionList) {
	    var data = {
	      showWizard: showWizard,
	      materials: materialsForSessionList
	    };
	
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/sessions/" + key + "/start"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON,
	      data: data
	    }).then(SessionService.onServiceComplete);
	  };
	
	  SessionService.getSession = function (key) {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/sessions/" + key),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(SessionService.onServiceComplete);
	  };
	
	  SessionService.createSession = function (sessionObj) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/sessions"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON,
	      data: sessionObj
	    }).then(SessionService.onServiceComplete);
	  };
	
	  SessionService.updateSession = function (sessionObj) {
	    return _request2.default.put({
	      url: _utils2.default.getServiceUrl("/sessions/" + sessionObj.key),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON,
	      data: sessionObj
	    }).then(SessionService.onServiceComplete);
	  };
	
	  SessionService.setThumb = function (sessionKey, thumbKey) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/sessions/" + sessionKey + "/set_thumb"),
	      cache: false,
	      data: {
	        thumb_key: thumbKey
	      }
	    }).then(SessionService.onServiceComplete);
	  };
	
	  SessionService.deleteSession = function (sessionKey) {
	    return _request2.default.delete({
	      url: _utils2.default.getServiceUrl("/sessions/" + sessionKey),
	      cache: false
	    }).then(SessionService.onServiceComplete);
	  };
	
	  SessionService.copySession = function (sessionKey) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/sessions/" + sessionKey + "/copy"),
	      cache: false
	    }).then(SessionService.onServiceComplete);
	  };
	
	  SessionService.addMission = function (sessionKey, missionKey) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/sessions/" + sessionKey + "/add_mission/" + missionKey),
	      cache: false
	    }).then(SessionService.onServiceComplete);
	  };
	
	  SessionService.onServiceComplete = function (data) {
	    if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	      return data.data;
	    }
	
	    return null;
	  };
	})(SessionService);
	
	module.exports = SessionService;

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _request = __webpack_require__(29);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClassService = {};
	
	(function (ClassService) {
	  ClassService.getClasses = function () {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/classes"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  ClassService.createClass = function (schoolKey, className) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/classes"),
	      cache: false,
	      data: {
	        name: className,
	        "school-key": schoolKey
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  ClassService.updateClass = function (classKey, schoolKey, className) {
	    return _request2.default.put({
	      url: _utils2.default.getServiceUrl("/classes/" + classKey + "/"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON,
	      data: {
	        key: classKey,
	        schoolKey: schoolKey,
	        name: className
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  ClassService.deleteClass = function (classKey) {
	    return _request2.default.delete({
	      url: _utils2.default.getServiceUrl("/classes/" + classKey),
	      cache: false
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  ClassService.getStudents = function (classKey) {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/classes/" + classKey + "/students"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	})(ClassService);
	
	module.exports = ClassService;

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _request = __webpack_require__(29);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LabelService = {};
	
	(function (LabelService) {
	  LabelService.getAllLabels = function () {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/labels"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	})(LabelService);
	
	module.exports = LabelService;

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _missionToggle = __webpack_require__(629);
	
	var _missionToggle2 = _interopRequireDefault(_missionToggle);
	
	__webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import NavUtils from "Sources/utils/navigation-utils";
	var log = __webpack_require__(4)();
	
	var MissionToggle = function () {
	  function MissionToggle(options) {
	    _classCallCheck(this, MissionToggle);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.mission = options.mission;
	    this.onMissionClicked = options.onMissionClicked;
	    this.onCopyMission = options.onCopyMission;
	    this.onDeleteMission = options.onDeleteMission;
	    this.selected = false;
	    this.blocked = false;
	    this.checkbox = options.checkbox;
	  }
	
	  _createClass(MissionToggle, [{
	    key: "setUpMissionIcon",
	    value: function setUpMissionIcon() {
	      switch (this.mission.source) {
	        case "standard_mission":
	          this.$element.find(".icn_mission_cartamundi").show();
	          break;
	
	        case "school_shared":
	          this.$element.find(".icn_school").show();
	          break;
	
	        case "user_shared":
	          this.$element.find(".icn_user").show();
	          break;
	
	        case "owner":
	          this.$element.find(".icn_user").show();
	          break;
	
	        case null:
	          this.$element.find(".icn_mission_cartamundi").show();
	          break;
	
	        default:
	          this.$element.find(".icn_user").show();
	          break;
	      }
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	
	      var COPY_BTN = ".copy-mission-btn";
	      var DELETE_BTN = ".delete-mission-btn";
	
	      var that = this;
	      this.$element.on("click", function (e) {
	        that.missionClicked();
	      });
	
	      this.$element.find(COPY_BTN).on("click", function (e) {
	        e.stopPropagation();
	        that.copyMission();
	      });
	
	      this.$element.find(DELETE_BTN).on("click", function (e) {
	        e.stopPropagation();
	        that.deleteMission();
	      });
	
	      this.$element.on("dragstart", function (e) {
	        //e.preventDefault();
	        e.stopPropagation();
	        that.onMissionDrag(e);
	      });
	    }
	  }, {
	    key: "onMissionDrag",
	    value: function onMissionDrag(e) {
	      e.dataTransfer.setData("mission/id", this.mission.key);
	      e.dataTransfer.effectAllowed = "copy";
	    }
	  }, {
	    key: "missionClicked",
	    value: function missionClicked() {
	      if (!this.blocked) {
	        this.toggleSelected();
	        this.onMissionClicked(this);
	      }
	    }
	  }, {
	    key: "toggleSelected",
	    value: function toggleSelected() {
	      if (this.$element.hasClass("selected")) {
	        this.selected = false;
	        this.$element.removeClass("selected");
	      } else {
	        this.selected = true;
	        this.$element.addClass("selected");
	      }
	    }
	  }, {
	    key: "setBlocked",
	    value: function setBlocked() {
	      this.blocked = true;
	      this.selected = false;
	      this.$element.removeClass("selected");
	      this.$element.addClass("blocked");
	    }
	  }, {
	    key: "setUnblocked",
	    value: function setUnblocked() {
	      this.blocked = false;
	      this.$element.removeClass("blocked");
	    }
	  }, {
	    key: "setUnselected",
	    value: function setUnselected() {
	      this.selected = false;
	      this.$element.removeClass("selected");
	    }
	  }, {
	    key: "hideButtons",
	    value: function hideButtons() {
	      this.$element.find(".copy-mission-btn").hide();
	      this.$element.find(".delete-mission-btn").hide();
	    }
	  }, {
	    key: "copyMission",
	    value: function copyMission() {
	      this.onCopyMission(this.mission);
	    }
	  }, {
	    key: "deleteMission",
	    value: function deleteMission() {
	      //TODO: remove mission from potential group
	      this.onDeleteMission(this);
	      this.destroy();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_missionToggle2.default);
	      this.$container.append(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	
	      this.updateMissionToggle();
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "updateMissionToggle",
	    value: function updateMissionToggle() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var $missionName = this.$element.find("[data-bind-target='mission-label-name']");
	        $missionName.empty();
	
	        if (_utils2.default.isNotNull(this.mission) && _utils2.default.isNotNull(this.mission.name)) {
	          $missionName.text(this.mission.name);
	        }
	
	        if (this.checkbox) {
	          var $checkbox = this.$element.find(".checkbox");
	          $checkbox.show();
	        } else {
	          var _$checkbox = this.$element.find(".checkbox");
	          _$checkbox.hide();
	        }
	      }
	    }
	  }, {
	    key: "mission",
	    get: function get() {
	      return this._mission;
	    },
	    set: function set(mission) {
	      this._mission = mission;
	      this.updateMissionToggle();
	    }
	  }], [{
	    key: "setUpMissionToggle",
	    value: function setUpMissionToggle(options) {
	      var instance = new MissionToggle(options);
	      instance.render();
	
	      if (options.hideButtons) {
	        instance.hideButtons();
	      }
	
	      if (options.clickable) {
	        instance.setUpEventListeners();
	      }
	
	      if (options.checkbox) {
	        //instance.showCheckbox();
	      }
	
	      instance.setUpMissionIcon();
	
	      return instance;
	    }
	  }]);
	
	  return MissionToggle;
	}();
	
	exports.default = MissionToggle;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _missionMaterialCategory = __webpack_require__(623);
	
	var _missionMaterialCategory2 = _interopRequireDefault(_missionMaterialCategory);
	
	var _missionMaterial = __webpack_require__(263);
	
	var _missionMaterial2 = _interopRequireDefault(_missionMaterial);
	
	__webpack_require__(177);
	
	var _util = __webpack_require__(22);
	
	var _missionMaterial3 = __webpack_require__(205);
	
	var _missionMaterial4 = _interopRequireDefault(_missionMaterial3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import NavUtils from "Sources/utils/navigation-utils";
	var log = __webpack_require__(4)();
	
	var MissionMaterialCategory = function () {
	  function MissionMaterialCategory(options) {
	    _classCallCheck(this, MissionMaterialCategory);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.category = options.category;
	    this.materials = options.materials;
	    this.showCheckmarks = options.showCheckmarks;
	    this.showMaterialAmountPicker = options.showMaterialAmountPicker;
	    this.categoryOpen = false;
	    this.materialObjects = [];
	    this.initialState = options.selected;
	  }
	
	  _createClass(MissionMaterialCategory, [{
	    key: "setInitialState",
	    value: function setInitialState(selected) {
	      if (selected) {
	        this.selectAllMaterials();
	        //this.updateCheckbox();
	        this.updateCategory();
	      }
	    }
	  }, {
	    key: "setUpMaterials",
	    value: function setUpMaterials(maxAmount) {
	      this.materialObjects = [];
	
	      var that = this;
	
	      //set up material elements
	      this.materials.forEach(function (material) {
	
	        var container = "#materials-" + that.category.key;
	
	        var materialObject = _missionMaterial4.default.setUpMissionMaterial({ container: container,
	          material: {
	            key: material.key,
	            name: material.name,
	            amount: material.amount
	          },
	          maxAmount: maxAmount,
	          selected: material.selected,
	          showCheckmark: that.showCheckmarks,
	          showAmount: that.showMaterialAmountPicker,
	          onMaterialAmountOpened: that.onMaterialAmountOpened.bind(that),
	          onMaterialSelected: that.onMaterialSelected.bind(that)
	        });
	        that.materialObjects.push(materialObject);
	      });
	
	      this.updateCategory();
	    }
	  }, {
	    key: "onMaterialAmountOpened",
	    value: function onMaterialAmountOpened() {
	      //close all
	      this.materialObjects.forEach(function (material) {
	        material.closeAndUpdate();
	      });
	    }
	  }, {
	    key: "onMaterialSelected",
	    value: function onMaterialSelected() {
	      this.updateCategory();
	    }
	  }, {
	    key: "getMaterials",
	    value: function getMaterials() {
	      var mats = [];
	      this.materialObjects.forEach(function (material) {
	        mats.push(material);
	      });
	
	      return mats;
	    }
	  }, {
	    key: "getSelectedMaterials",
	    value: function getSelectedMaterials() {
	      var selectedMaterials = [];
	      this.materialObjects.forEach(function (material) {
	        if (material.selected) {
	          selectedMaterials.push(material);
	        }
	      });
	
	      return selectedMaterials;
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	
	      var TOGGLE_OPEN_BTN_ID = ".open-category-btn";
	      var CHECKBOX_ID = ".special-checkbox";
	      var HEADER_LABEL_ID = ".category-header-label";
	
	      var that = this;
	      this.$element.find(TOGGLE_OPEN_BTN_ID).on("click", function (e) {
	        that.categoryOpenToggle();
	      });
	
	      this.$element.find(HEADER_LABEL_ID).on("click", function (e) {
	        that.categoryOpenToggle();
	      });
	
	      this.$element.find(CHECKBOX_ID).on("click", function (e) {
	        if (that.getSelectedMaterials().length === that.materials.length) {
	          that.unselectAllMaterials();
	        } else {
	          that.selectAllMaterials();
	        }
	        that.updateCategory();
	      });
	    }
	  }, {
	    key: "unselectAllMaterials",
	    value: function unselectAllMaterials() {
	      this.materialObjects.forEach(function (material) {
	        material.setUnselected();
	      });
	    }
	  }, {
	    key: "selectAllMaterials",
	    value: function selectAllMaterials() {
	      this.materialObjects.forEach(function (material) {
	        material.setSelected();
	      });
	    }
	  }, {
	    key: "categoryOpenToggle",
	    value: function categoryOpenToggle() {
	      if (this.categoryOpen) {
	        this.$element.find(".category-materials").show();
	        this.$element.find(".open-category-btn").addClass("open");
	      } else {
	        this.$element.find(".category-materials").hide();
	        this.$element.find(".open-category-btn").removeClass("open");
	      }
	      this.categoryOpen = !this.categoryOpen;
	    }
	  }, {
	    key: "updateCheckbox",
	    value: function updateCheckbox() {
	
	      if (this.$element) {
	        var $checkbox = this.$element.find(".special-checkbox");
	        switch (this.getSelectedMaterials().length) {
	          case 0:
	            $checkbox.removeClass("checked").removeClass("partial");
	            break;
	
	          case this.materials.length:
	            $checkbox.addClass("checked").removeClass("partial");
	            break;
	
	          default:
	            $checkbox.removeClass("checked").addClass("partial");
	            break;
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_missionMaterialCategory2.default);
	      this.$container.prepend(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	
	      this.updateCategory();
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "updateCategory",
	    value: function updateCategory() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var $categoryName = this.$element.find("[data-bind-target='category-name']");
	        $categoryName.empty();
	
	        if (_utils2.default.isNotNull(this.category) && _utils2.default.isNotNull(this.category.name)) {
	          $categoryName.text(this.category.name);
	        }
	
	        var $materialCount = this.$element.find("[data-bind-target='category-material-count']");
	        $materialCount.empty();
	        $materialCount.text(" (" + this.getSelectedMaterials().length + "/" + this.materials.length + ")");
	
	        var $categoryLabel = this.$element.find("[data-bind-target='category-label']");
	        if (_utils2.default.isNotNull(this.category) && _utils2.default.isNotNull(this.category.key)) {
	          $categoryLabel.attr("for", this.category.key);
	        }
	
	        var $categoryCheckbox = this.$element.find("[data-bind-target='category-checkbox']");
	        if (_utils2.default.isNotNull(this.category) && _utils2.default.isNotNull(this.category.key)) {
	          $categoryCheckbox.attr("id", this.category.key);
	        }
	
	        var $materialWrapper = this.$element.find("[data-bind-target='category-materials']");
	        if (_utils2.default.isNotNull(this.category) && _utils2.default.isNotNull(this.category.key)) {
	          $materialWrapper.attr("id", "materials-" + this.category.key);
	        }
	      }
	
	      this.updateCheckbox();
	    }
	  }, {
	    key: "updateMaterials",
	    value: function updateMaterials() {
	      var $materials = this.$element.find("[data-bind-target='category-materials']");
	      $materials.empty();
	
	      this.category.materials.forEach(function (material) {
	        var $element = $(_missionMaterial2.default);
	        var $materialName = $element.find("[data-bind-target='material-name']");
	        $materialName.text(material.name);
	
	        $materials.append($element);
	        _languageManager2.default.applyLocale($element);
	      });
	    }
	  }, {
	    key: "showMaterial",
	    value: function showMaterial(material) {
	
	      this.category.materials.push(material);
	      this.updateMaterials();
	    }
	  }, {
	    key: "category",
	    get: function get() {
	      return this._category;
	    },
	    set: function set(category) {
	      this._category = category;
	      this.updateCategory();
	    }
	  }], [{
	    key: "setUpMissionMaterialCategory",
	    value: function setUpMissionMaterialCategory(options) {
	      var instance = new MissionMaterialCategory(options);
	      instance.render();
	      instance.setUpMaterials(options.maxAmount);
	      instance.setInitialState(instance.initialState);
	      instance.setUpEventListeners();
	      return instance;
	    }
	  }]);
	
	  return MissionMaterialCategory;
	}();
	
	exports.default = MissionMaterialCategory;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _sessionStudentLabel = __webpack_require__(644);
	
	var _sessionStudentLabel2 = _interopRequireDefault(_sessionStudentLabel);
	
	__webpack_require__(580);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import NavUtils from "Sources/utils/navigation-utils";
	var log = __webpack_require__(4)();
	
	var SessionStudentLabel = function () {
	  function SessionStudentLabel(options) {
	    _classCallCheck(this, SessionStudentLabel);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.studentLabel = options.studentLabel;
	    this.onStudentClicked = options.onStudentClicked;
	    this.getStudentIndex = options.getStudentIndex;
	    this.inGroup = options.inGroup;
	    this.canBeClicked = options.canBeClicked;
	    this.selected = false;
	    this.blocked = false;
	  }
	
	  _createClass(SessionStudentLabel, [{
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var that = this;
	      this.$element.on("click", function (e) {
	        that.studentClicked();
	      });
	
	      this.$element.on("dragstart", function (e) {
	        //e.preventDefault();
	        e.stopPropagation();
	        that.onStudentDrag(e);
	      });
	    }
	  }, {
	    key: "onStudentDrag",
	    value: function onStudentDrag(e) {
	      e.dataTransfer.setData("student/id", this.getStudentIndex(this));
	      e.dataTransfer.effectAllowed = "copy";
	
	      if (!this.inGroup) {} else {}
	    }
	  }, {
	    key: "studentClicked",
	    value: function studentClicked() {
	      if (!this.blocked && this.canBeClicked) {
	        this.toggleSelected();
	        this.onStudentClicked(this);
	      }
	    }
	  }, {
	    key: "toggleSelected",
	    value: function toggleSelected() {
	      if (this.$element.hasClass("selected")) {
	        this.selected = false;
	        this.$element.removeClass("selected");
	      } else {
	        this.selected = true;
	        this.$element.addClass("selected");
	      }
	    }
	  }, {
	    key: "setBlocked",
	    value: function setBlocked() {
	      this.blocked = true;
	      this.selected = false;
	      this.$element.removeClass("selected");
	      this.$element.addClass("blocked");
	    }
	  }, {
	    key: "setUnblocked",
	    value: function setUnblocked() {
	      this.blocked = false;
	      this.$element.removeClass("blocked");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_sessionStudentLabel2.default);
	      this.$container.append(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	
	      this.updateSessionStudentLabel();
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "updateSessionStudentLabel",
	    value: function updateSessionStudentLabel() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var $studentLabelName = this.$element.find("[data-bind-target='student-label-name']");
	        $studentLabelName.empty();
	
	        if (_utils2.default.isNotNull(this.studentLabel) && _utils2.default.isNotNull(this.studentLabel.name)) {
	          $studentLabelName.text(this.studentLabel.name);
	        }
	      }
	    }
	  }, {
	    key: "studentLabel",
	    get: function get() {
	      return this._studentLabel;
	    },
	    set: function set(studentLabel) {
	      this._studentLabel = studentLabel;
	      this.updateSessionStudentLabel();
	    }
	  }], [{
	    key: "setUpSessionStudentLabel",
	    value: function setUpSessionStudentLabel(options) {
	      var instance = new SessionStudentLabel(options);
	      instance.render();
	      instance.setUpEventListeners();
	      return instance;
	    }
	  }]);
	
	  return SessionStudentLabel;
	}();
	
	exports.default = SessionStudentLabel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _request = __webpack_require__(29);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaterialService = {};
	
	(function (MaterialService) {
	  MaterialService.getAllMaterials = function () {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/materials"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  MaterialService.getAllMaterialCategories = function () {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/material_categories"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	})(MaterialService);
	
	module.exports = MaterialService;

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _missionSharedUser = __webpack_require__(628);
	
	var _missionSharedUser2 = _interopRequireDefault(_missionSharedUser);
	
	__webpack_require__(261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import NavUtils from "Sources/utils/navigation-utils";
	var log = __webpack_require__(4)();
	
	var MissionSharedUser = function () {
	    function MissionSharedUser(options) {
	        _classCallCheck(this, MissionSharedUser);
	
	        this.$container = $(options.container);
	        this.hasRendered = false;
	        this.missionSharedUser = options.missionSharedUser;
	        this.onSharedUserRemoved = options.onSharedUserRemoved;
	        this.selected = false;
	    }
	
	    _createClass(MissionSharedUser, [{
	        key: "setUpEventListeners",
	        value: function setUpEventListeners() {
	            var REMOVE_BTN_ID = ".remove-btn";
	
	            var that = this;
	            this.$element.find(REMOVE_BTN_ID).on("click", function (e) {
	                that.removeUser();
	            });
	        }
	    }, {
	        key: "removeUser",
	        value: function removeUser() {
	            this.onSharedUserRemoved(this.missionSharedUser.key);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            this.hasRendered = false;
	            this.$element = $(_missionSharedUser2.default);
	            this.$container.prepend(this.$element);
	            _languageManager2.default.applyLocale(this.$element);
	            this.updateMissionSharedUser();
	            this.hasRendered = true;
	        }
	    }, {
	        key: "show",
	        value: function show() {
	            if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	                this.$element.show();
	            }
	        }
	    }, {
	        key: "hide",
	        value: function hide() {
	            if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	                this.$element.hide();
	            }
	        }
	    }, {
	        key: "destroy",
	        value: function destroy() {
	            if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	                this.$element.remove();
	            }
	        }
	    }, {
	        key: "updateMissionSharedUser",
	        value: function updateMissionSharedUser() {
	            if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	                var $userNameLabel = this.$element.find("[data-bind-target='user-name-label']");
	                $userNameLabel.empty();
	                if (_utils2.default.isNotNull(this.missionSharedUser) && _utils2.default.isNotNull(this.missionSharedUser.email)) {
	                    $userNameLabel.text(this.missionSharedUser.email);
	                }
	            }
	        }
	    }, {
	        key: "getEmail",
	        value: function getEmail() {
	            return this.missionSharedUser.email;
	        }
	    }, {
	        key: "missionSharedUser",
	        get: function get() {
	            return this._missionSharedUser;
	        },
	        set: function set(missionSharedUser) {
	            this._missionSharedUser = missionSharedUser;
	            this.updateMissionSharedUser();
	        }
	    }], [{
	        key: "setUpMissionSharedUser",
	        value: function setUpMissionSharedUser(options) {
	            var instance = new MissionSharedUser(options);
	            instance.render();
	            instance.setUpEventListeners();
	            return instance;
	        }
	    }]);
	
	    return MissionSharedUser;
	}();
	
	exports.default = MissionSharedUser;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _sessionImageButton = __webpack_require__(640);
	
	var _sessionImageButton2 = _interopRequireDefault(_sessionImageButton);
	
	__webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import NavUtils from "Sources/utils/navigation-utils";
	var log = __webpack_require__(4)();
	
	var SessionImageButton = function () {
	  function SessionImageButton(options) {
	    _classCallCheck(this, SessionImageButton);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.imageButton = options.imageButton;
	    this.imageFolder = options.imageFolder;
	    this.onImageSelected = options.onImageSelected;
	    this.selected = false;
	  }
	
	  _createClass(SessionImageButton, [{
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var that = this;
	      this.$element.on("click", function (e) {
	        that.onImageSelected(that.imageButton.key, that.imageButton.url);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_sessionImageButton2.default);
	      this.$container.append(this.$element);
	
	      this.updateSessionImageButton();
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "updateSessionImageButton",
	    value: function updateSessionImageButton() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        if (_utils2.default.isNotNull(this.imageButton) && _utils2.default.isNotNull(this.imageButton.key)) {
	          var imageUrl = this.imageButton.url;
	          this.$element.find("img").attr("src", imageUrl);
	        }
	      }
	    }
	  }, {
	    key: "imageButton",
	    get: function get() {
	      return this._imageButton;
	    },
	    set: function set(imageButton) {
	      this._imageButton = imageButton;
	      this.updateSessionImageButton();
	    }
	  }], [{
	    key: "setUpSessionImageButton",
	    value: function setUpSessionImageButton(options) {
	      var instance = new SessionImageButton(options);
	      instance.render();
	      instance.setUpEventListeners();
	      return instance;
	    }
	  }]);
	
	  return SessionImageButton;
	}();
	
	exports.default = SessionImageButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(107);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SessionMaterial = function () {
	  function SessionMaterial(options) {
	    _classCallCheck(this, SessionMaterial);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.sessionMaterialKey = options.sessionMaterialKey;
	    this.name = options.name;
	    this.imageUrl = options.url;
	  }
	
	  _createClass(SessionMaterial, [{
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      //this.$element = $(HtmlTemplate);
	
	      this.$element = $("<img />", {
	        class: "material-icon",
	        src: this.imageUrl,
	        alt: this.name,
	        title: this.name
	      });
	
	      this.$container.append(this.$element);
	      //LanguageManager.applyLocale(this.$element);
	
	      this.hasRendered = true;
	    }
	  }, {
	    key: "removeFromContainer",
	    value: function removeFromContainer() {
	      this.$element.remove();
	    }
	  }], [{
	    key: "createInstance",
	    value: function createInstance(options) {
	      var instance = new SessionMaterial(options);
	      instance.render();
	
	      return instance;
	    }
	  }]);
	
	  return SessionMaterial;
	}();
	
	exports.default = SessionMaterial;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _request = __webpack_require__(29);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CurriculumObjectiveService = {};
	
	(function (CurriculumObjectiveService) {
	  CurriculumObjectiveService.getAllCurriculumCategories = function () {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/curriculum_categories"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  CurriculumObjectiveService.getAllCurriculumObjectives = function () {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/curriculum_objectives"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	})(CurriculumObjectiveService);
	
	module.exports = CurriculumObjectiveService;

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var utils = __webpack_require__(2);
	var log = __webpack_require__(4)();
	var UserServices = __webpack_require__(25);
	var StorageController = __webpack_require__(21);
	var AppError = __webpack_require__(213);
	
	var LoginManager = {};
	
	(function (LoginManager) {
	  LoginManager.ERRORS = {
	    USERNAME_PASSWORD_INCORRECT: "username_password_incorrect",
	    INCOMPLETE_PROFILE: "incomplete_profile",
	    USER_NOT_VERIFIED: "user_not_verified",
	    NO_USER_DATA: "no_user_data",
	    UNEXPECTED: "unexpected"
	  };
	
	  LoginManager.logout = function () {
	
	    StorageController.removeFromLocal(StorageController.keys.LOGGED_IN_USER);
	    StorageController.clearAll();
	
	    /*
	    UserServices.logout()
	      .finally(() =>
	      {
	      });
	      */
	  };
	
	  LoginManager.login = function (username, password) {
	    // LoginManager.logout(() =>
	    // {
	    //   _login(username, password, successCb, failCb);
	    // });
	
	    // We no longer logout since the server does that for us now
	    return _login(username, password);
	  };
	
	  function _login(username, password) {
	    $("html").addClass("waiting");
	
	    StorageController.removeFromLocal(StorageController.keys.LOGGED_IN_USER);
	    StorageController.clearAll();
	
	    return UserServices.authenticateUser(username, password)
	    // [catch] before [then] because [then] throws new errors which would otherwise be caught by this [catch]
	    .catch(function (data) {
	      // Fail
	      log.error("Failed to authenticate - %o", data);
	      $("html").removeClass("waiting");
	
	      throw new AppError({
	        data: {
	          data: data,
	          errorType: LoginManager.ERRORS.UNEXPECTED
	        },
	        exception: new Error("Unexpected error occurred")
	      });
	    }).then(function (data) {
	      // Success
	      var xmlDoc = $($.parseXML(data));
	      var referrer = xmlDoc.find("access-control").attr("referer");
	      var xmlData = xmlDoc.find("access-control").find("data").text();
	
	      log.info("Login xml data: %s", xmlData);
	
	      $("html").removeClass("waiting");
	
	      if (isSuccess(xmlDoc)) {
	        var userData = utils.parseJSON(xmlData, true);
	
	        if (utils.isNullOrEmpty(userData)) {
	          log.error("User data is empty in login response");
	
	          throw new AppError({
	            data: {
	              data: data,
	              errorType: LoginManager.ERRORS.NO_USER_DATA
	            },
	            exception: new Error("User data is empty in login response")
	          });
	        }
	
	        if (!userData.hasOwnProperty("authenticated") || userData.authenticated) {
	          // Success
	          return {
	            userData: userData,
	            referer: referrer
	          };
	        } else {
	          // login failed (wrong credentials)
	          throw new AppError({
	            data: {
	              data: data,
	              errorType: LoginManager.ERRORS.USERNAME_PASSWORD_INCORRECT
	            },
	            exception: new Error("Tried to login with wrong credentials")
	          });
	        }
	      } else if (isError(xmlDoc)) {
	        var errorData = utils.parseJSON(xmlData, true);
	
	        if (utils.isNotNull(errorData)) {
	          if (errorData.incomplete) {
	            //incomplete profile
	            throw new AppError({
	              data: {
	                data: data,
	                errorType: LoginManager.ERRORS.INCOMPLETE_PROFILE
	              },
	              exception: new Error("Tried to login while profile is incomplete")
	            });
	          } else if (utils.isNotNull(errorData.errorCode)) {
	            //incomplete profile
	            throw new AppError({
	              code: errorData.errorCode,
	              data: {
	                data: data,
	                errorType: getErrorForCode(errorData.errorCode)
	              },
	              exception: new Error("Tried to login while profile is incomplete")
	            });
	          }
	        }
	
	        throw new AppError({
	          data: {
	            data: data,
	            errorType: LoginManager.ERRORS.USERNAME_PASSWORD_INCORRECT
	          },
	          exception: new Error("Tried to login with wrong credentials")
	        });
	      } else {
	        // always fun to say: should not come here... :)
	        throw new AppError({
	          data: {
	            data: data,
	            errorType: LoginManager.ERRORS.UNEXPECTED
	          },
	          exception: new Error("Unexpected error occurred")
	        });
	      }
	    });
	  }
	
	  function is(what, xml) {
	    return xml.find("access-control").attr("result") === what;
	  }
	
	  function isSuccess(xml) {
	    return is("success", xml);
	  }
	
	  function isError(xml) {
	    return is("error", xml);
	  }
	
	  function isNotLoggedIn(xml) {
	    return is("null", xml);
	  }
	
	  function getErrorForCode(code) {
	    if (code === "E45370") {
	      return LoginManager.ERRORS.UNEXPECTED;
	    } else if (code === "E55053") {
	      return LoginManager.ERRORS.USER_NOT_VERIFIED;
	    }
	
	    return LoginManager.ERRORS.UNEXPECTED;
	  }
	})(LoginManager);
	
	module.exports = LoginManager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavUtils = {}; /**
	                    * Created by jv on 2020-02-07 (15:34).
	                    */
	
	
	NavUtils.setNavHighlight = function (href) {
	  href = _utils2.default.isNotNull(href) ? href : _utils2.default.getUrlPath();
	  var $navLinks = $(".navbar-nav .nav-item a.nav-link");
	  $navLinks.removeClass("active");
	
	  $navLinks.each(function (index, el) {
	    var $el = $(el);
	    var navLink = $el.attr("href"),
	        alternatives = $el.data("link-alternatives");
	
	    var matches = false;
	    var alternativeLinkExpressions = _utils2.default.isNotNull(alternatives) ? alternatives.split(";") : [];
	
	    if (href === navLink || alternativeLinkExpressions.includes(href)) {
	      matches = true;
	    } else {
	      // Try via regex to see if it matches
	      for (var i = 0; i < alternativeLinkExpressions.length; i++) {
	        var regexp = new RegExp(alternativeLinkExpressions[i]);
	
	        if (href.match(regexp)) {
	          matches = true;
	          break;
	        }
	      }
	    }
	
	    if (matches) {
	      $el.addClass("active");
	    }
	  });
	};
	
	exports.default = NavUtils;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _sessionCustomMaterialItem = __webpack_require__(636);
	
	var _sessionCustomMaterialItem2 = _interopRequireDefault(_sessionCustomMaterialItem);
	
	__webpack_require__(261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var log = __webpack_require__(4)();
	
	var CustomMaterialsListItem = function () {
	  function CustomMaterialsListItem(options) {
	    _classCallCheck(this, CustomMaterialsListItem);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.material = options.material;
	    this.onRemoved = options.onRemoved;
	    this.usesRemoveButton = options.usesRemoveButton;
	    this.usesCheckbox = options.usesCheckbox;
	    this.disableInput = options.disableInput;
	    this.hideInput = options.hideInput;
	    this.material.amount = options.material.maxAmount;
	    this.material.selected = options.selected;
	  }
	
	  _createClass(CustomMaterialsListItem, [{
	    key: "setInitialState",
	    value: function setInitialState(selected) {
	      if (selected) {
	        this.$element.find(".material-checkbox").prop("checked", true);
	        this.$element.find(".amount-input").val(this.material.amount).trigger("change");
	      } else {
	        this.$element.find(".material-checkbox").prop("checked", true);
	        this.$element.find(".amount-input").val(0);
	      }
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var REMOVE_BTN_ID = ".remove-btn";
	      var AMOUNT_FIELD_ID = ".amount-input";
	      var CHECKBOX_ID = ".material-checkbox";
	
	      var that = this;
	      this.$element.find(REMOVE_BTN_ID).on("click", function (e) {
	        that.removeMaterial();
	      });
	
	      this.$element.find(AMOUNT_FIELD_ID).on("change", function (e) {
	        that.setAmount(that.$element.find(AMOUNT_FIELD_ID).val());
	      });
	
	      this.$element.find(CHECKBOX_ID).on("change", function (e) {
	        if (e.target.checked) {
	          that.material.selected = true;
	          that.material.amount = parseInt(that.$element.find(AMOUNT_FIELD_ID).val());
	        } else {
	          that.material.selected = false;
	          that.material.amount = 0;
	        }
	      });
	    }
	  }, {
	    key: "setAmount",
	    value: function setAmount(amount) {
	      this.material.amount = amount;
	    }
	  }, {
	    key: "setOriginalAmount",
	    value: function setOriginalAmount() {
	      if (_utils2.default.isNotNull(this.material.amount)) {
	        this.$element.find(".amount-input").val(this.material.amount).trigger("change");
	      }
	    }
	  }, {
	    key: "removeMaterial",
	    value: function removeMaterial() {
	      this.onRemoved(this.material.key, this.material.name);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_sessionCustomMaterialItem2.default);
	      this.$container.prepend(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	      this.updateCustomMaterialsListItem();
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "updateCustomMaterialsListItem",
	    value: function updateCustomMaterialsListItem() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var $materialName = this.$element.find("[data-bind-target='material-name-label']");
	        $materialName.empty();
	        if (_utils2.default.isNotNull(this.material) && _utils2.default.isNotNull(this.material.name)) {
	          $materialName.text(this.material.name);
	          $materialName.attr("for", "material-checkbox-" + this.material.key);
	        }
	
	        var $materialCheckbox = this.$element.find("[data-bind-target='material-checkbox']");
	        if (this.usesCheckbox) {
	          $materialCheckbox.empty();
	
	          if (_utils2.default.isNotNull(this.material) && _utils2.default.isNotNull(this.material.key)) {
	            $materialCheckbox.attr("id", "material-checkbox-" + this.material.key);
	          }
	
	          $(".custom-control-label").removeClass("no-before");
	        } else {
	          $(".custom-control-label").addClass("no-before");
	        }
	
	        var $removeButton = this.$element.find(".remove-btn");
	        if (this.usesRemoveButton) {
	          $removeButton.show();
	        } else {
	          $removeButton.hide();
	        }
	
	        var $amountInput = this.$element.find(".amount-input");
	        if (_utils2.default.isNotNull(this.material.maxAmount)) {
	          $amountInput.val(this.material.amount);
	          $amountInput.attr("max", this.material.maxAmount);
	        }
	
	        if (this.disableInput) {
	          $amountInput.prop("disabled", true);
	        } else {
	          $amountInput.prop("disabled", false);
	        }
	
	        if (this.hideInput) {
	          $amountInput.hide();
	        } else {
	          $amountInput.show();
	        }
	      }
	    }
	  }, {
	    key: "material",
	    get: function get() {
	      return this._material;
	    },
	    set: function set(material) {
	      this._material = material;
	      this.updateCustomMaterialsListItem();
	    }
	  }], [{
	    key: "setUpCustomMaterialsListItem",
	    value: function setUpCustomMaterialsListItem(options) {
	      var instance = new CustomMaterialsListItem(options);
	      instance.render();
	      instance.setOriginalAmount();
	      instance.setInitialState(instance.material.amount);
	      instance.setUpEventListeners();
	
	      return instance;
	    }
	  }]);
	
	  return CustomMaterialsListItem;
	}();
	
	exports.default = CustomMaterialsListItem;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _missionLabel = __webpack_require__(626);
	
	var _missionLabel2 = _interopRequireDefault(_missionLabel);
	
	__webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import NavUtils from "Sources/utils/navigation-utils";
	var log = __webpack_require__(4)();
	
	var MissionLabel = function () {
	  function MissionLabel(options) {
	    _classCallCheck(this, MissionLabel);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.missionLabel = options.missionLabel;
	    this.selected = false;
	    this.visible = false;
	  }
	
	  _createClass(MissionLabel, [{
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	
	      var that = this;
	      this.$element.on("click", function (e) {
	        that.toggleSelected();
	      });
	    }
	  }, {
	    key: "toggleSelected",
	    value: function toggleSelected() {
	      if (this.$element.hasClass("selected")) {
	        this.selected = false;
	        this.$element.removeClass("selected");
	      } else {
	        this.selected = true;
	        this.$element.addClass("selected");
	      }
	    }
	  }, {
	    key: "toggleVisible",
	    value: function toggleVisible() {
	      if (this.visible) {
	        this.setVisibility(false);
	      } else {
	        this.setVisibility(true);
	      }
	    }
	  }, {
	    key: "setVisibility",
	    value: function setVisibility(visibility) {
	      if (visibility) {
	        this.visible = true;
	        this.$element.show();
	      } else {
	        this.visible = false;
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_missionLabel2.default);
	      this.$container.append(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	
	      this.updateMissionLabel();
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "updateMissionLabel",
	    value: function updateMissionLabel() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var $missionLabelName = this.$element.find("[data-bind-target='mission-label-name']");
	        $missionLabelName.empty();
	
	        if (_utils2.default.isNotNull(this.missionLabel) && _utils2.default.isNotNull(this.missionLabel.missionLabelName)) {
	          $missionLabelName.text(this.missionLabel.missionLabelName);
	        }
	      }
	    }
	  }, {
	    key: "missionLabel",
	    get: function get() {
	      return this._missionLabel;
	    },
	    set: function set(missionLabel) {
	      this._missionLabel = missionLabel;
	      this.updateMissionLabel();
	    }
	  }], [{
	    key: "setUpMissionLabel",
	    value: function setUpMissionLabel(options) {
	      var instance = new MissionLabel(options);
	      instance.render();
	      if (options.selected) {
	        instance.toggleSelected();
	      }
	      instance.setUpEventListeners();
	      return instance;
	    }
	  }]);
	
	  return MissionLabel;
	}();
	
	exports.default = MissionLabel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _missionMaterial = __webpack_require__(263);
	
	var _missionMaterial2 = _interopRequireDefault(_missionMaterial);
	
	__webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import NavUtils from "Sources/utils/navigation-utils";
	var log = __webpack_require__(4)();
	
	var MissionMaterial = function () {
	  function MissionMaterial(options) {
	    _classCallCheck(this, MissionMaterial);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.material = options.material;
	    this.onMaterialAmountOpened = options.onMaterialAmountOpened;
	    this.onMaterialSelected = options.onMaterialSelected;
	    this.showCheckmark = options.showCheckmark;
	    this.selected = false;
	    this.infinite = false;
	    this.showAmount = options.showAmount;
	    this.maxAmount = options.maxAmount;
	  }
	
	  _createClass(MissionMaterial, [{
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var AMOUNT_FIELD_ID = ".amount-input";
	      var CHECKBOX_ID = ".material-checkbox";
	      var AMOUNT_CLOSED_ID = ".material-amount-closed";
	      var AMOUNT_CLOSED_TEXT_ID = ".material-amount-closed p";
	      var INFINITE_BTN_ID = ".material-infinite-btn";
	
	      var that = this;
	      this.$element.find(AMOUNT_FIELD_ID).on("change", function (e) {
	        that.infinite = false;
	        that.material.amount = parseInt($(e.target).val());
	        that.updateMissionMaterial();
	      });
	
	      this.$element.find(CHECKBOX_ID).on("change", function (e) {
	        if (e.target.checked) {
	          that.selected = true;
	          that.material.amount = parseInt(that.$element.find(AMOUNT_FIELD_ID).val());
	        } else {
	          that.selected = false;
	        }
	        that.onMaterialSelected();
	      });
	
	      this.$element.find(INFINITE_BTN_ID).on("click", function (e) {
	        that.infinite = true;
	        that.material.amount = 0;
	        that.$element.find(".material-amount-open").hide();
	        that.updateMissionMaterial();
	      });
	
	      this.$element.find(AMOUNT_CLOSED_TEXT_ID).on("click", function (e) {
	        var $amountOpen = that.$element.find(".material-amount-open");
	        if ($amountOpen.is(":visible")) {
	          that.$element.find(".material-amount-open").hide();
	          that.updateMissionMaterial();
	        } else {
	          that.onMaterialAmountOpened();
	          that.$element.find(".material-amount-open").show();
	        }
	      });
	
	      this.$element.find(AMOUNT_CLOSED_ID).on("click", function (e) {
	        if (e.target === this) {
	          var $amountOpen = that.$element.find(".material-amount-open");
	          if ($amountOpen.is(":visible")) {
	            that.$element.find(".material-amount-open").hide();
	            that.updateMissionMaterial();
	          } else {
	            if (that.selected) {
	              that.onMaterialAmountOpened();
	              that.$element.find(".material-amount-open").show();
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: "setUnselected",
	    value: function setUnselected() {
	      this.$element.find(".material-checkbox").prop("checked", false);
	      this.selected = false;
	    }
	  }, {
	    key: "setSelected",
	    value: function setSelected() {
	      this.$element.find(".material-checkbox").prop("checked", true);
	      this.selected = true;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_missionMaterial2.default);
	      this.$container.prepend(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	
	      this.updateMissionMaterial();
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "closeAndUpdate",
	    value: function closeAndUpdate() {
	      this.$element.find(".material-amount-open").hide();
	      this.updateMissionMaterial();
	    }
	  }, {
	    key: "updateMissionMaterial",
	    value: function updateMissionMaterial() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var $materialName = this.$element.find("[data-bind-target='material-name']");
	        $materialName.empty();
	
	        if (_utils2.default.isNotNull(this.material) && _utils2.default.isNotNull(this.material.name) && _utils2.default.isNotNull(this.material.key)) {
	          $materialName.text(this.material.name);
	          $materialName.attr("for", "material-checkbox-" + this.material.key);
	        }
	
	        var $materialCount = this.$element.find("[data-bind-target='material-count']");
	        $materialCount.empty();
	
	        var $materialCheckbox = this.$element.find("[data-bind-target='material-checkbox']");
	        $materialCheckbox.empty();
	
	        if (_utils2.default.isNotNull(this.material) && _utils2.default.isNotNull(this.material.key)) {
	          $materialCheckbox.attr("id", "material-checkbox-" + this.material.key);
	        }
	
	        var $materialClosedLabel = this.$element.find("[data-bind-target='material-amount-closed-label']");
	
	        var $amountInput = this.$element.find(".amount-input");
	        $amountInput.val(this.material.amount);
	        $amountInput.attr("max", this.maxAmount);
	
	        /*
	        if(this.infinite)
	        {
	          $materialClosedLabel.text(LanguageManager.getValueForKey("mission_material.infinite_btn"));
	        }
	        else
	        {
	          let amountValue = this.$element.find("[data-bind-target='material-count-input']").val();
	          if(utils.isNotNull(amountValue))
	          {
	            $materialClosedLabel.text(this.$element.find("[data-bind-target='material-count-input']").val());
	          }
	          else
	          {
	           }
	        }
	          */
	
	        if (this.showAmount) {
	          $(".amount-input").show();
	        } else {
	          $(".amount-input").hide();
	        }
	      }
	    }
	  }, {
	    key: "material",
	    get: function get() {
	      return this._material;
	    },
	    set: function set(material) {
	      this._material = material;
	      this.updateMissionMaterial();
	    }
	  }], [{
	    key: "setUpMissionMaterial",
	    value: function setUpMissionMaterial(options) {
	      var instance = new MissionMaterial(options);
	      instance.render();
	      if (options.selected) {
	        instance.setSelected();
	        //instance.onMaterialSelected();
	      }
	
	      if (!_utils2.default.isNullOrEmpty(options.maxAmount) || !_utils2.default.isUndefined(options.maxAmount)) {
	        instance.material.amount = options.maxAmount;
	      } else {
	        instance.material.amount = 0;
	      }
	
	      if (!options.showCheckmark) {
	        instance.$element.find("[data-bind-target='material-checkbox']").hide();
	      }
	
	      instance.updateMissionMaterial();
	
	      instance.setUpEventListeners();
	      return instance;
	    }
	  }]);
	
	  return MissionMaterial;
	}();
	
	exports.default = MissionMaterial;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _missionObjectiveCategory = __webpack_require__(632);
	
	var _missionObjectiveCategory2 = _interopRequireDefault(_missionObjectiveCategory);
	
	var _missionObjective = __webpack_require__(264);
	
	var _missionObjective2 = _interopRequireDefault(_missionObjective);
	
	__webpack_require__(177);
	
	var _util = __webpack_require__(22);
	
	var _missionObjective3 = __webpack_require__(337);
	
	var _missionObjective4 = _interopRequireDefault(_missionObjective3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import NavUtils from "Sources/utils/navigation-utils";
	var log = __webpack_require__(4)();
	
	var MissionObjectiveCategory = function () {
	  function MissionObjectiveCategory(options) {
	    _classCallCheck(this, MissionObjectiveCategory);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.category = options.category;
	    this.objectives = options.objectives;
	    this.showCheckmarks = options.showCheckmarks;
	    this.categoryOpen = false;
	    this.objectiveObjects = [];
	  }
	
	  _createClass(MissionObjectiveCategory, [{
	    key: "setUpObjectives",
	    value: function setUpObjectives() {
	      this.objectiveObjects = [];
	
	      var that = this;
	
	      //set up objective elements
	      this.objectives.forEach(function (objective) {
	        var container = "#objectives-" + that.category.key;
	
	        var objectiveObject = _missionObjective4.default.setUpMissionObjective({ container: container,
	          objective: {
	            key: objective.key,
	            name: objective.name,
	            category: objective.category,
	            code: objective.code
	          },
	          selected: objective.selected,
	          showCheckmark: that.showCheckmarks,
	          onObjectiveSelected: that.onObjectiveSelected.bind(that)
	        });
	        that.objectiveObjects.push(objectiveObject);
	      });
	
	      this.updateCategory();
	    }
	  }, {
	    key: "onObjectiveSelected",
	    value: function onObjectiveSelected() {
	      this.updateCategory();
	    }
	  }, {
	    key: "getSelectedObjectives",
	    value: function getSelectedObjectives() {
	      var selectedObjectives = [];
	      this.objectiveObjects.forEach(function (objective) {
	        if (objective.selected) {
	          selectedObjectives.push(objective);
	        }
	      });
	
	      return selectedObjectives;
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	
	      var TOGGLE_OPEN_BTN_ID = ".open-category-btn";
	      var CHECKBOX_ID = ".special-checkbox";
	      var HEADER_LABEL_ID = ".category-header-label";
	
	      var that = this;
	      this.$element.find(TOGGLE_OPEN_BTN_ID).on("click", function (e) {
	        that.categoryOpenToggle();
	      });
	
	      this.$element.find(HEADER_LABEL_ID).on("click", function (e) {
	        that.categoryOpenToggle();
	      });
	
	      this.$element.find(CHECKBOX_ID).on("click", function (e) {
	        if (that.getSelectedObjectives().length === that.objectives.length) {
	          that.unselectAllObjectives();
	        } else {
	          that.selectAllObjectives();
	        }
	        that.updateCategory();
	      });
	    }
	  }, {
	    key: "unselectAllObjectives",
	    value: function unselectAllObjectives() {
	      this.objectiveObjects.forEach(function (objective) {
	        objective.setUnselected();
	      });
	    }
	  }, {
	    key: "selectAllObjectives",
	    value: function selectAllObjectives() {
	      this.objectiveObjects.forEach(function (objective) {
	        objective.setSelected();
	      });
	    }
	  }, {
	    key: "categoryOpenToggle",
	    value: function categoryOpenToggle() {
	      if (this.categoryOpen) {
	        this.$element.find(".category-objectives").show();
	        this.$element.find(".open-category-btn").addClass("open");
	      } else {
	        this.$element.find(".category-objectives").hide();
	        this.$element.find(".open-category-btn").removeClass("open");
	      }
	      this.categoryOpen = !this.categoryOpen;
	    }
	  }, {
	    key: "updateCheckbox",
	    value: function updateCheckbox() {
	
	      if (this.$element) {
	        var $checkbox = this.$element.find(".special-checkbox");
	        switch (this.getSelectedObjectives().length) {
	          case 0:
	            $checkbox.removeClass("checked").removeClass("partial");
	            break;
	
	          case this.objectives.length:
	            $checkbox.addClass("checked").removeClass("partial");
	            break;
	
	          default:
	            $checkbox.removeClass("checked").addClass("partial");
	            break;
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_missionObjectiveCategory2.default);
	      this.$container.prepend(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	
	      this.updateCategory();
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "updateCategory",
	    value: function updateCategory() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var $categoryName = this.$element.find("[data-bind-target='category-name']");
	        $categoryName.empty();
	
	        if (_utils2.default.isNotNull(this.category) && _utils2.default.isNotNull(this.category.name)) {
	          $categoryName.text(this.category.name);
	        }
	
	        var $categoryLabel = this.$element.find("[data-bind-target='category-label']");
	        if (_utils2.default.isNotNull(this.category) && _utils2.default.isNotNull(this.category.key)) {
	          $categoryLabel.attr("for", this.category.key);
	        }
	
	        var $objectiveCount = this.$element.find("[data-bind-target='category-objective-count']");
	        $objectiveCount.empty();
	        $objectiveCount.text(" (" + this.getSelectedObjectives().length + "/" + this.objectives.length + ")");
	
	        var $categoryCheckbox = this.$element.find("[data-bind-target='category-checkbox']");
	        if (_utils2.default.isNotNull(this.category) && _utils2.default.isNotNull(this.category.key)) {
	          $categoryCheckbox.attr("id", this.category.key);
	        }
	
	        var $objectiveWrapper = this.$element.find("[data-bind-target='category-objectives']");
	        if (_utils2.default.isNotNull(this.category) && _utils2.default.isNotNull(this.category.key)) {
	          $objectiveWrapper.attr("id", "objectives-" + this.category.key);
	        }
	      }
	      this.updateCheckbox();
	    }
	  }, {
	    key: "updateObjectives",
	    value: function updateObjectives() {
	      var $objectives = this.$element.find("[data-bind-target='category-objectives']");
	      $objectives.empty();
	
	      this.category.objectives.forEach(function (objective) {
	        var $element = $(_missionObjective2.default);
	        var $objectiveName = $element.find("[data-bind-target='objective-name']");
	        $objectiveName.text(objective.name);
	
	        $objectives.append($element);
	        _languageManager2.default.applyLocale($element);
	      });
	    }
	  }, {
	    key: "showObjective",
	    value: function showObjective(objective) {
	
	      this.category.objectives.push(objective);
	      this.updateObjectives();
	    }
	  }, {
	    key: "category",
	    get: function get() {
	      return this._category;
	    },
	    set: function set(category) {
	      this._category = category;
	      this.updateCategory();
	    }
	  }], [{
	    key: "setUpMissionObjectiveCategory",
	    value: function setUpMissionObjectiveCategory(options) {
	      var instance = new MissionObjectiveCategory(options);
	      instance.render();
	      instance.setUpObjectives();
	      instance.setUpEventListeners();
	      instance.categoryOpenToggle();
	      return instance;
	    }
	  }]);
	
	  return MissionObjectiveCategory;
	}();
	
	exports.default = MissionObjectiveCategory;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _mission = __webpack_require__(630);
	
	var _mission2 = _interopRequireDefault(_mission);
	
	var _missionService = __webpack_require__(47);
	
	var _missionService2 = _interopRequireDefault(_missionService);
	
	__webpack_require__(575);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import NavUtils from "Sources/utils/navigation-utils";
	var log = __webpack_require__(4)();
	
	var Mission = function () {
	  function Mission(options) {
	    _classCallCheck(this, Mission);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.mission = options.mission;
	    this.onFavorite = options.onFavoriteClicked;
	    this.onAddToSession = options.onAddToSessionClicked;
	    this.onDelete = options.onDeleteClicked;
	    this.onCopy = options.onCopyClicked;
	    this.deleteable = options.deleteable;
	    this.copyable = options.copyable;
	    this.missionList = options.missionList;
	    this.labelString = "";
	    this.mission.selected = options.selected;
	    this.showCheckbox = options.showCheckbox;
	  }
	
	  _createClass(Mission, [{
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var FAVORITE_BTN_ID = ".favorite-mission-btn";
	      var ADDTOSESSION_BTN_ID = ".add-to-session-btn";
	      var COPY_BTN_ID = ".copy-mission-btn";
	      var DELETE_BTN_ID = ".delete-mission-btn";
	      var CHECKBOX = ".mission-checkbox__checkbox";
	
	      var that = this;
	      this.$element.find(FAVORITE_BTN_ID).on("click", function (e) {
	        that.favoriteMission();
	      });
	
	      this.$element.find(ADDTOSESSION_BTN_ID).on("click", function (e) {
	        that.addToSession();
	      });
	
	      this.$element.find(CHECKBOX).on("change", function (e) {
	        that.onCheckboxChanged(this.checked);
	      });
	
	      this.$element.find(COPY_BTN_ID).on("click", function (e) {
	        that.onCopy(that.mission);
	      });
	
	      this.$element.find(DELETE_BTN_ID).on("click", function (e) {
	        that.onDelete(that.mission);
	      });
	    }
	  }, {
	    key: "getLabels",
	    value: function getLabels() {
	      var _this = this;
	
	      this.mission.labels.forEach(function (label) {
	        _this.labelString += label + ", ";
	      });
	    }
	  }, {
	    key: "onCheckboxChanged",
	    value: function onCheckboxChanged(checked) {
	      this.mission.selected = checked;
	      this.addToSession();
	    }
	  }, {
	    key: "setCheckbox",
	    value: function setCheckbox(checkboxState) {
	      var $checkbox = this.$element.find(".mission-checkbox__checkbox");
	      $checkbox.prop("checked", checkboxState);
	    }
	  }, {
	    key: "addToSession",
	    value: function addToSession() {
	      //this.mission.selected = !this.mission.selected;
	      if (_utils2.default.isNotNull(this.missionList)) {
	        this.missionList.onAddToSessionClicked(this.mission);
	      } else {
	        this.onAddToSession(this.mission.key);
	      }
	      this.updateMission();
	    }
	  }, {
	    key: "removeFromSession",
	    value: function removeFromSession() {}
	  }, {
	    key: "favoriteMission",
	    value: function favoriteMission() {
	      var _this2 = this;
	
	      var that = this;
	      if (this.mission.favorite) {
	        _missionService2.default.unfavoriteMission(this.mission.key).then(function (data) {
	          _this2.onFavorite(_this2.mission);
	        }).catch(function (err) {
	          // TODO handle errors
	        });
	      } else {
	        _missionService2.default.favoriteMission(this.mission.key).then(function (data) {
	          _this2.onFavorite(_this2.mission);
	        }).catch(function (err) {
	          // TODO handle errors
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_mission2.default);
	      this.$container.prepend(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	
	      this.updateMission();
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "updateMission",
	    value: function updateMission() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var $missionName = this.$element.find("[data-bind-target='mission-name']");
	        $missionName.empty();
	
	        if (_utils2.default.isNotNull(this.mission) && _utils2.default.isNotNull(this.mission.name) && _utils2.default.isNotNull(this.mission.key)) {
	          $missionName.text(this.mission.name);
	          $missionName.attr("href", "/mission-detail/" + this.mission.key);
	        }
	
	        var $missionDate = this.$element.find("[data-bind-target='mission-date']");
	        $missionDate.empty();
	
	        if (_utils2.default.isNotNull(this.mission) && _utils2.default.isNotNull(this.mission.created)) {
	          $missionDate.text(this.mission.created);
	        }
	
	        var $missionLabels = this.$element.find("[data-bind-target='mission-labels']");
	        $missionLabels.empty();
	
	        if (_utils2.default.isNotNull(this.mission) && _utils2.default.isNotNull(this.labelString)) {
	          $missionLabels.text(this.labelString);
	        }
	
	        var $missionAuthor = this.$element.find("[data-bind-target='mission-author']");
	        $missionAuthor.empty();
	
	        if (_utils2.default.isNotNull(this.mission) && _utils2.default.isNotNull(this.mission.userName)) {
	          $missionAuthor.text(this.mission.userName);
	        }
	
	        var $favoriteIcon = this.$element.find(".icn_favourite");
	        if (_utils2.default.isNotNull(this.mission) && _utils2.default.isNotNull(this.mission.favorite)) {
	          if (this.mission.favorite === true) {
	            $favoriteIcon.removeClass("empty");
	            $favoriteIcon.addClass("filled");
	          } else {
	            $favoriteIcon.removeClass("filled");
	            $favoriteIcon.addClass("empty");
	          }
	        }
	
	        var $deleteIcon = this.$element.find(".delete-mission-btn");
	        if (this.deleteable) {
	          $deleteIcon.show();
	        } else {
	          $deleteIcon.hide();
	        }
	
	        var $copyIcon = this.$element.find(".copy-mission-btn");
	        if (this.copyable) {
	          $copyIcon.show();
	        } else {
	          $copyIcon.hide();
	        }
	
	        this.showIcon();
	
	        var $checkbox = this.$element.find(".custom-checkbox");
	        var $addIcon = this.$element.find(".icn_add");
	
	        if (this.showCheckbox) {
	          $checkbox.show();
	          $addIcon.hide();
	        } else {
	          $checkbox.hide();
	          $addIcon.show();
	        }
	      }
	    }
	  }, {
	    key: "showIcon",
	    value: function showIcon() {
	      switch (this.mission.source) {
	        case "standard_mission":
	          this.$element.find(".icn_mission_cartamundi").show();
	          break;
	
	        case "school_shared":
	          this.$element.find(".icn_school").show();
	          break;
	
	        case "user_shared":
	          this.$element.find(".icn_user").show();
	          break;
	
	        case "owner":
	          this.$element.find(".icn_user").show();
	          break;
	
	        case null:
	          this.$element.find(".icn_mission_cartamundi").show();
	          break;
	
	        default:
	          this.$element.find(".icn_user").show();
	          break;
	      }
	    }
	  }, {
	    key: "mission",
	    get: function get() {
	      return this._mission;
	    },
	    set: function set(mission) {
	      this._mission = mission;
	      this.updateMission();
	    }
	  }], [{
	    key: "setUpMission",
	    value: function setUpMission(options) {
	      var instance = new Mission(options);
	      instance.getLabels();
	      instance.render();
	      instance.setUpEventListeners();
	
	      if (instance.showCheckbox) {
	        instance.setCheckbox(instance.mission.selected);
	      }
	
	      return instance;
	    }
	  }]);
	
	  return Mission;
	}();
	
	exports.default = Mission;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _schoolCheckbox = __webpack_require__(631);
	
	var _schoolCheckbox2 = _interopRequireDefault(_schoolCheckbox);
	
	var _missionService = __webpack_require__(47);
	
	var _missionService2 = _interopRequireDefault(_missionService);
	
	__webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import NavUtils from "Sources/utils/navigation-utils";
	var log = __webpack_require__(4)();
	
	var SchoolCheckbox = function () {
	  function SchoolCheckbox(options) {
	    _classCallCheck(this, SchoolCheckbox);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.schoolCheckbox = options.school;
	    this.selected = false;
	  }
	
	  _createClass(SchoolCheckbox, [{
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var LABEL_BTN_ID = ".mission-label";
	
	      var that = this;
	      this.$element.find("[data-bind-target='school-checkbox-checkbox']").on("change", function (e) {
	        that.toggleSelected();
	      });
	    }
	  }, {
	    key: "toggleSelected",
	    value: function toggleSelected() {
	      this.selected = !this.selected;
	    }
	  }, {
	    key: "setSelected",
	    value: function setSelected() {
	      this.$element.find("[data-bind-target='school-checkbox-checkbox']").prop("checked", true);
	      this.selected = true;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_schoolCheckbox2.default);
	      this.$container.append(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	
	      this.updateSchoolCheckbox();
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "updateSchoolCheckbox",
	    value: function updateSchoolCheckbox() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var $schoolCheckboxName = this.$element.find("[data-bind-target='school-checkbox-label']");
	        $schoolCheckboxName.empty();
	
	        if (_utils2.default.isNotNull(this.schoolCheckbox) && _utils2.default.isNotNull(this.schoolCheckbox.name) && _utils2.default.isNotNull(this.schoolCheckbox.key)) {
	          $schoolCheckboxName.text(this.schoolCheckbox.name);
	          $schoolCheckboxName.attr("for", "school-checkbox-" + this.schoolCheckbox.key);
	        }
	
	        var $schoolCheckboxBox = this.$element.find("[data-bind-target='school-checkbox-checkbox']");
	        $schoolCheckboxBox.empty();
	
	        if (_utils2.default.isNotNull(this.schoolCheckbox) && _utils2.default.isNotNull(this.schoolCheckbox.key)) {
	          $schoolCheckboxBox.attr("id", "school-checkbox-" + this.schoolCheckbox.key);
	        }
	      }
	    }
	  }, {
	    key: "schoolCheckbox",
	    get: function get() {
	      return this._schoolCheckbox;
	    },
	    set: function set(schoolCheckbox) {
	      this._schoolCheckbox = schoolCheckbox;
	      this.updateSchoolCheckbox();
	    }
	  }], [{
	    key: "setUpSchoolCheckbox",
	    value: function setUpSchoolCheckbox(options) {
	      var instance = new SchoolCheckbox(options);
	      instance.render();
	      if (options.selected) {
	        instance.setSelected();
	      }
	      instance.setUpEventListeners();
	      return instance;
	    }
	  }]);
	
	  return SchoolCheckbox;
	}();
	
	exports.default = SchoolCheckbox;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2020-02-07 (12:11).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _school = __webpack_require__(634);
	
	var _school2 = _interopRequireDefault(_school);
	
	var _schoolClass = __webpack_require__(633);
	
	var _schoolClass2 = _interopRequireDefault(_schoolClass);
	
	var _classService = __webpack_require__(87);
	
	var _classService2 = _interopRequireDefault(_classService);
	
	__webpack_require__(577);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import NavUtils from "Sources/utils/navigation-utils";
	var log = __webpack_require__(4)();
	
	var School = function () {
	  function School(options) {
	    _classCallCheck(this, School);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.school = options.school;
	    this.onRemove = options.onRemoveClicked;
	    this.onClassRemove = options.onClassRemoveClicked;
	    this.showGlobalError = options.showGlobalError;
	    this.studentCount = 0;
	    this.classToRemove;
	  }
	
	  _createClass(School, [{
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var REMOVESCHOOL_BTN_ID = ".delete-school-btn";
	
	      var that = this;
	      this.$element.find(REMOVESCHOOL_BTN_ID).on("click", function (e) {
	        e.preventDefault();
	        that.removeSchool();
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_school2.default);
	      this.$container.prepend(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	
	      this.updateSchool();
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "updateSchool",
	    value: function updateSchool() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var $schoolName = this.$element.find("[data-bind-target='school-name']");
	        $schoolName.empty();
	
	        if (_utils2.default.isNotNull(this.school) && _utils2.default.isNotNull(this.school.name)) {
	          $schoolName.text(this.school.name);
	        }
	
	        var $addressLineStreet = this.$element.find("[data-bind-target='address-line-street']");
	        $addressLineStreet.empty();
	
	        if (_utils2.default.isNotNull(this.school) && _utils2.default.isNotNull(this.school.addressLineStreet)) {
	          $addressLineStreet.text(this.school.addressLineStreet);
	        }
	
	        var $addressLineCity = this.$element.find("[data-bind-target='address-line-city']");
	        $addressLineCity.empty();
	
	        if (_utils2.default.isNotNull(this.school) && _utils2.default.isNotNull(this.school.addressLineCity)) {
	          $addressLineCity.text(this.school.addressLineCity);
	        }
	
	        var $phoneNumber = this.$element.find("[data-bind-target='phone-number']");
	        $phoneNumber.empty();
	
	        if (_utils2.default.isNotNull(this.school) && _utils2.default.isNotNull(this.school.phoneNumber)) {
	          $phoneNumber.text(this.school.phoneNumber);
	        }
	
	        if (_utils2.default.isNotNull(this.school.key)) {
	          var $addClassButton = this.$element.find("[data-bind-target='create-class-button']");
	          $addClassButton.attr("href", "create-class/" + this.school.key);
	        }
	      }
	    }
	  }, {
	    key: "updateClasses",
	    value: function updateClasses() {
	      var _this = this;
	
	      var $classes = this.$element.find("[data-bind-target='school-classes']");
	      $classes.empty();
	
	      this.school.schoolClasses.forEach(function (schoolClass) {
	        var $element = $(_schoolClass2.default);
	        var $className = $element.find("[data-bind-target='class-name']");
	        $className.text(schoolClass.name);
	        var $pupilCount = $element.find("[data-bind-target='pupil-count']");
	        $pupilCount.text(schoolClass.studentCount);
	        $element.attr("href", "/edit-class/" + schoolClass.key);
	
	        var that = _this;
	        $element.find(".remove-class-btn").on("click", function (e) {
	          e.preventDefault();
	          that.classToRemove = schoolClass.key;
	          that.onClassRemove(that.school.key);
	        });
	
	        $classes.append($element);
	        _languageManager2.default.applyLocale($element);
	      });
	    }
	  }, {
	    key: "removeClass",
	    value: function removeClass() {
	      var _this2 = this;
	
	      var that = this;
	
	      _classService2.default.deleteClass(this.classToRemove).then(function () {
	        that.school.schoolClasses.splice(that.school.schoolClasses.findIndex(function (schoolClass) {
	          return schoolClass.key === that.classToRemove;
	        }), 1);
	        that.updateClasses();
	        //this.showGlobalError("success");
	      }).catch(function (appError) {
	        _this2.showGlobalError(appError.code);
	        log.error("could not delete class");
	      });
	    }
	  }, {
	    key: "removeSchool",
	    value: function removeSchool() {
	      this.onRemove(this.school.key);
	    }
	  }, {
	    key: "showClass",
	    value: function showClass(schoolClass) {
	      this.school.schoolClasses.push(schoolClass);
	      this.updateClasses();
	    }
	  }, {
	    key: "school",
	    get: function get() {
	      return this._school;
	    },
	    set: function set(school) {
	      this._school = school;
	      this.updateSchool();
	    }
	  }], [{
	    key: "setUpSchool",
	    value: function setUpSchool(options) {
	      var instance = new School(options);
	      instance.render();
	      instance.setUpEventListeners();
	      return instance;
	    }
	  }]);
	
	  return School;
	}();
	
	exports.default = School;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2020-02-11 (14:47).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	__webpack_require__(578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var COLLAPSED_CLASS = "search-input-collapsed";
	
	var SearchInputExpand = function () {
	  function SearchInputExpand(options) {
	    _classCallCheck(this, SearchInputExpand);
	
	    // selector should be search-input-wrapper
	    this.element = $(options.selector);
	    this.setUpEventListeners();
	
	    this.onSearchRequest = options.onSearchRequest;
	  }
	
	  _createClass(SearchInputExpand, [{
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var _this = this;
	
	      this.element.find("input.form-control").on("blur", function (e) {
	        var $this = $(e.currentTarget);
	        var inputValue = $this.val();
	
	        if (_utils2.default.isNullOrEmpty(inputValue)) {
	          _this.element.addClass(COLLAPSED_CLASS);
	        }
	      });
	
	      this.element.find("input.form-control").on("keyup", function (e) {
	        var $this = $(e.currentTarget);
	
	        if (_utils2.default.isNotNull(e.key) || e.keyCode === 13) {
	          if (_utils2.default.isFunction(_this.onSearchRequest)) {
	            _this.onSearchRequest.call(_this, $this.val());
	          }
	        }
	      });
	
	      this.element.on("click", function (e) {
	        _this.element.removeClass(COLLAPSED_CLASS);
	        _this.element.find("input.form-control").first().focus();
	      });
	    }
	  }]);
	
	  return SearchInputExpand;
	}();
	
	exports.default = SearchInputExpand;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _sessionMaterialsList = __webpack_require__(642);
	
	var _sessionMaterialsList2 = _interopRequireDefault(_sessionMaterialsList);
	
	var _shared = __webpack_require__(8);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _missionMaterialCategory = __webpack_require__(114);
	
	var _missionMaterialCategory2 = _interopRequireDefault(_missionMaterialCategory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import NavUtils from "Sources/utils/navigation-utils";
	var log = __webpack_require__(4)();
	
	var SessionMaterialsList = function () {
	  function SessionMaterialsList(options) {
	    _classCallCheck(this, SessionMaterialsList);
	
	    this.$container = $(options.container);
	    this.onSetUpMaterialsDone = options.onSetUpMaterialsDone;
	    this.hasRendered = false;
	    this.allCategories = [];
	    this.allMaterials = [];
	    this.materials = [];
	    this.categories = [];
	  }
	
	  _createClass(SessionMaterialsList, [{
	    key: "setUpCategories",
	    value: function setUpCategories(materials) {
	      var _this = this;
	
	      //if(materials.count > 0)
	      //{
	      materials.forEach(function (material) {
	        var categoryKey = _this.allMaterials.find(function (mat) {
	          return mat.key === material.materialKey;
	        }).materialCategoryKey;
	        if (categoryKey) {
	          _this.setUpCategory(categoryKey);
	        }
	      });
	      //}
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {}
	  }, {
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_sessionMaterialsList2.default);
	      this.$container.append(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "setUpAllMaterials",
	    value: function setUpAllMaterials(materials) {
	      this.allMaterials = materials;
	    }
	  }, {
	    key: "updateMaterialsFromGroups",
	    value: function updateMaterialsFromGroups(groups) {
	      var _this2 = this;
	
	      this.materials = [];
	      this.categories = [];
	
	      $("#materials-wrapper").empty();
	
	      var that = this;
	      groups.forEach(function (group) {
	        if (_utils2.default.isNotNull(group.mission)) {
	          _this2.addMaterialsToList(group.mission.mission.missionMaterialList);
	        }
	      });
	
	      if (this.materials.length > 0) {
	        $(".materials-placeholder-text").hide();
	      } else {
	        $(".materials-placeholder-text").show();
	      }
	    }
	  }, {
	    key: "updateMaterials",
	    value: function updateMaterials(materials) {
	      this.materials = [];
	      this.categories = [];
	
	      $("#materials-wrapper").empty();
	      this.addMaterialsToList(materials);
	
	      if (this.materials.length > 0) {
	        $(".materials-placeholder-text").hide();
	      } else {
	        $(".materials-placeholder-text").show();
	      }
	    }
	  }, {
	    key: "addMaterialsToList",
	    value: function addMaterialsToList(materials) {
	      var _this3 = this;
	
	      this.setUpCategories(materials);
	      materials.forEach(function (material) {
	
	        if (_this3.allMaterials.find(function (mat) {
	          return mat.key === material.materialKey;
	        })) {
	          var newMaterial = {
	            materialKey: material.materialKey,
	            amount: material.amount,
	            name: _this3.allMaterials.find(function (mat) {
	              return mat.key === material.materialKey;
	            }).name,
	            categoryKey: _this3.allMaterials.find(function (mat) {
	              return mat.key === material.materialKey;
	            }).materialCategoryKey
	          };
	
	          var oldMaterial = _this3.materials.find(function (oldMaterial) {
	            return oldMaterial.materialKey === newMaterial.materialKey;
	          });
	          if (_utils2.default.isUndefined(oldMaterial)) {
	            _this3.materials.push(newMaterial);
	            _this3.setUpMaterial(newMaterial);
	          } else {
	            _this3.addToMaterialAmount(newMaterial);
	          }
	        }
	      });
	    }
	  }, {
	    key: "addToMaterialAmount",
	    value: function addToMaterialAmount(newMaterial) {
	      this.materials.forEach(function (material) {
	        if (material.materialKey === newMaterial.materialKey) {
	          //todo: keep infinite if other occurrence is infinite
	          if (material.amount === 0) {
	            var amountString = _languageManager2.default.getValueForKey("mission_material.infinite_btn");
	            $("#" + material.materialKey).text(material.name + " (" + amountString + ")");
	            //$("#" + material.materialKey).text(material.name);
	          } else {
	            material.amount += newMaterial.amount;
	            $("#" + material.materialKey).text(material.name + " (" + material.amount + ")");
	            //$("#" + material.materialKey).text(material.name);
	          }
	        }
	      });
	    }
	  }, {
	    key: "setUpMaterial",
	    value: function setUpMaterial(materialObj) {
	
	      if (this.allMaterials.find(function (material) {
	        return material.key === materialObj.materialKey;
	      })) {
	
	        var amountString = "";
	        if (materialObj.amount === 0) {
	          amountString = _languageManager2.default.getValueForKey("mission_material.infinite_btn");
	        } else {
	          amountString = materialObj.amount;
	        }
	
	        //let el = "<p class='material-list-item' id='" + materialObj.materialKey + "'>" + materialObj.name + " (" + amountString + ")</p>";
	        var el = "<p class='material-list-item' id='" + materialObj.materialKey + "'>" + materialObj.name + ", </p>";
	        $(".category-" + materialObj.categoryKey).append($(el));
	      } else {
	        //material does not exist in allMaterials
	      }
	    }
	  }, {
	    key: "setUpCategory",
	    value: function setUpCategory(categoryKey) {
	      var materialCategory = this.categories.find(function (cat) {
	        return cat.key === categoryKey;
	      });
	
	      if (!materialCategory) {
	        //create new category
	        var category = this.allCategories.find(function (cat) {
	          return cat.key === categoryKey;
	        });
	        if (!_utils2.default.isNullOrEmpty(category) || !_utils2.default.isUndefined(category)) {
	          this.categories.push(category);
	
	          var that = this;
	          var $catEl = $("<div class='materials-category open'>" + "<p class='material-category-title'>" + "<span><button class=\"icon-btn open-category-btn\">\n" + "  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9.105\" height=\"5.171\" viewBox=\"0 0 9.105 5.171\">\n" + "    <g id=\"icn_dropdown\" transform=\"translate(-59.299 -230.925)\">\n" + "      <path id=\"Path_41\" data-name=\"Path 41\" d=\"M67.8,230.925a.552.552,0,0,1,.551.383.563.563,0,0,1-.123.658l-3.947,3.947a.591.591,0,0,1-.857,0l-3.947-3.947a.562.562,0,0,1-.122-.658.552.552,0,0,1,.551-.383Z\" transform=\"translate(0 0)\"></path>\n" + "    </g>\n" + "  </svg>\n" + "</button></span>" + "<span>" + category.name + "</span>" + "</p>" + "<div class='category-materials category-" + category.key + "'>" + "</div>" + "</div>");
	          $catEl.find(".open-category-btn").on("click", function (e) {
	            that.toggleMatCategory($catEl);
	          });
	          $("#materials-wrapper").append($catEl);
	        }
	      }
	    }
	  }, {
	    key: "toggleMatCategory",
	    value: function toggleMatCategory($catEl) {
	      if ($catEl.hasClass("open")) {
	        $catEl.removeClass("open");
	      } else {
	        $catEl.addClass("open");
	      }
	    }
	
	    //NEW STUFF
	    /*
	      setUpCategories(allCategories, allMaterials) {
	        allCategories.forEach(function (category) {
	    
	          let categoryObject = MissionMaterialCategory.setUpMissionMaterialCategory({
	            container: ".materials-wrapper",
	            category: {
	              key: category.key,
	              localizationKey: category.localizationKey,
	              name: category.name,
	            },
	            materials: this.getMaterialsForCategory(category.key),
	            selected: false,
	            showCheckmarks: false,
	          })
	          this.materialCategories.push(categoryObject);
	        });
	      }
	    
	      getSelectedMaterials() {
	        let selectedMaterials = [];
	    
	        this.materialCategories.forEach(category => {
	          this.materials = category.getSelectedMaterials();
	          this.materials.forEach(material => {
	            selectedMaterials.push({materialKey: material.material.key, amount: material.material.amount});
	          });
	        });
	    
	        return selectedMaterials;
	      }
	    
	      getMaterialsForCategory(categoryKey) {
	        let categoryMaterials = [];
	        this.allMaterials.forEach(material => {
	          if (material.materialCategoryKey === categoryKey) {
	            //if the material was already selected, add amount
	            if (originalMission) {
	              let originalMat = originalMission.missionMaterialList.find(originalMat => originalMat.materialKey === material.key);
	              if (originalMat) {
	                material.selected = true;
	                material.amount = originalMat.amount;
	              }
	            }
	            categoryMaterials.push(material);
	          }
	        });
	    
	        return categoryMaterials;
	    }
	    
	     */
	
	  }], [{
	    key: "setUpSessionMaterialsList",
	    value: function setUpSessionMaterialsList(options, materialList) {
	      var instance = new SessionMaterialsList(options);
	      instance.render();
	      _shared2.default.getAllMaterialCategories().then(function (categories) {
	        instance.allCategories = categories;
	        //console.log(instance.allCategories);
	        _shared2.default.getAllMaterials().then(function (materials) {
	          instance.setUpAllMaterials(materials);
	          if (materialList) instance.updateMaterials(materialList);
	
	          instance.onSetUpMaterialsDone();
	        });
	      });
	      instance.setUpEventListeners();
	      return instance;
	    }
	  }]);
	
	  return SessionMaterialsList;
	}();
	
	exports.default = SessionMaterialsList;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _client = __webpack_require__(215);
	
	var _client2 = _interopRequireDefault(_client);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-09-11 (10:14).
	 */
	var log = __webpack_require__(4)();
	
	var RealtimeServiceController = function () {
	  function RealtimeServiceController(options) {
	    _classCallCheck(this, RealtimeServiceController);
	
	    this.baseUrl = options.baseUrl;
	    if (_utils2.default.isNotNull(this.baseUrl) && this.baseUrl.endsWith("/")) this.baseUrl = this.baseUrl.substring(0, this.baseUrl.length - 1);
	
	    this.onOpenListeners = [];
	    this.onCloseListeners = [];
	    this.onErrorListeners = [];
	    this.onMessageListeners = [];
	  }
	
	  _createClass(RealtimeServiceController, [{
	    key: "init",
	    value: function init() {
	      var _this = this;
	
	      this.url = this.baseUrl;
	
	      this.client = new _client2.default({
	        url: this.url,
	        onOpen: function onOpen(event) {
	          return _this._onSessionOpened(event);
	        },
	        onClose: function onClose(event) {
	          return _this._onSessionClosed(event);
	        },
	        onError: function onError(event) {
	          return _this._onSessionError(event);
	        },
	        onMessage: function onMessage(event) {
	          return _this._onSessionMessage(event);
	        }
	      });
	    }
	  }, {
	    key: "_onSessionOpened",
	    value: function _onSessionOpened(event) {
	      log.cssLog("Successfully established socket connection - %o", event, log.successCss);
	
	      for (var i = 0; i < this.onOpenListeners.length; i++) {
	        this.onOpenListeners[i].call(this, event);
	      }
	    }
	  }, {
	    key: "_onSessionClosed",
	    value: function _onSessionClosed(event) {
	      log.cssLog("Socket connection was closed - %o", event, log.warningCss);
	
	      for (var i = 0; i < this.onCloseListeners.length; i++) {
	        this.onCloseListeners[i].call(this, event);
	      }
	    }
	  }, {
	    key: "_onSessionError",
	    value: function _onSessionError(event) {
	      log.cssLog("An error occurred on the socket connection - %o", event, log.errorCss);
	
	      for (var i = 0; i < this.onErrorListeners.length; i++) {
	        this.onErrorListeners[i].call(this, event);
	      }
	    }
	  }, {
	    key: "_onSessionMessage",
	    value: function _onSessionMessage(event) {
	      for (var i = 0; i < this.onMessageListeners.length; i++) {
	        this.onMessageListeners[i].call(this, event);
	      }
	    }
	  }, {
	    key: "connect",
	    value: function connect() {
	      if (_utils2.default.isNotNull(this.client)) {
	        this.client.open();
	      }
	    }
	  }, {
	    key: "disconnect",
	    value: function disconnect() {
	      if (_utils2.default.isNotNull(this.client)) {
	        this.client.close();
	      }
	    }
	  }, {
	    key: "sendMessage",
	    value: function sendMessage(message) {
	      var serializedData = message.serialize();
	      log.info("Sending message to server: %o\nSerialized: %s", message, serializedData);
	
	      this.client.sendData(serializedData);
	    }
	  }, {
	    key: "addEventListener",
	    value: function addEventListener(type, func) {
	      if (_utils2.default.isNull(type) || !_utils2.default.isFunction(func)) return;
	
	      switch (type) {
	        case "session-opened":
	          this.onOpenListeners.push(func);
	          break;
	        case "session-closed":
	          this.onCloseListeners.push(func);
	          break;
	        case "session-error":
	          this.onErrorListeners.push(func);
	          break;
	        case "session-message":
	          this.onMessageListeners.push(func);
	          break;
	      }
	    }
	  }]);
	
	  return RealtimeServiceController;
	}();
	
	exports.default = RealtimeServiceController;

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 16/03/2017.
	 */
	var utils = __webpack_require__(2);
	
	var knownErrors = ["401", // unauthorized
	
	"E91489", "E73550"];
	
	module.exports = function () {
	  function AppError(options) {
	    _classCallCheck(this, AppError);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.code = options.appErrorCode || options.code;
	    this.message = options.message;
	
	    this.data = options.data;
	    this.exception = options.exception;
	  }
	
	  _createClass(AppError, [{
	    key: "readableErrorTitle",
	    get: function get() {
	      if ($.inArray(this.code, knownErrors) !== -1) {
	        return "errors.services." + this.code + ".title";
	      }
	
	      return "errors.services.general.title";
	    }
	  }, {
	    key: "readableErrorMessage",
	    get: function get() {
	      if ($.inArray(this.code, knownErrors) !== -1) {
	        //return "errors.services." + this.code + ".message";
	        return this.code;
	      }
	
	      return "errors.services.general.message";
	    }
	  }]);
	
	  return AppError;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _sessionMaterial = __webpack_require__(144);
	
	var _sessionMaterial2 = _interopRequireDefault(_sessionMaterial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SessionModel = function () {
	  function SessionModel(session) {
	    _classCallCheck(this, SessionModel);
	
	    this.extraMaterialList = session.extraMaterialList;
	    this.gameSessionState = session.gameSessionState;
	    this.materialList = session.materialList;
	    this.missionList = session.missionList;
	    this.sessionGroupList = session.sessionGroupList;
	    this.studentList = session.studentList;
	  }
	
	  _createClass(SessionModel, [{
	    key: "getMissionMaterials",
	    value: function getMissionMaterials(missionKey) {
	      var _this = this;
	
	      var materials = [];
	      var mission = this.getMission(missionKey);
	      if (_utils2.default.isNull(mission)) {
	        console.error("No mission found for key '" + missionKey + "'.");
	        return materials;
	      }
	
	      mission.missionMaterialList.forEach(function (missionMaterial) {
	        var material = _this.getMaterial(missionMaterial.materialKey);
	        if (_utils2.default.isNull(material)) {
	          console.error("No material found for key '" + missionMaterial.materialKey + "'.");
	        } else {
	          materials.push(material);
	        }
	      });
	
	      return materials;
	    }
	  }, {
	    key: "getSessionGroupInventory",
	    value: function getSessionGroupInventory(sessionGroupKey) {
	      var inventory = null;
	      //console.log(this.gameSessionState.inventoryList)
	      //console.log(this.gameSessionState)
	
	
	      this.gameSessionState.inventoryList.forEach(function (inv) {
	        if (inv.sessionGroupKey === sessionGroupKey) {
	          inventory = inv;
	        }
	      });
	
	      return inventory;
	    }
	  }, {
	    key: "getSessionMaterialForMaterialKey",
	    value: function getSessionMaterialForMaterialKey(materialKey) {
	      var returnObj = null;
	      this.gameSessionState.sessionMaterialList.forEach(function (sessionMaterial) {
	        if (_utils2.default.isNotNull(sessionMaterial.materialKey) && sessionMaterial.materialKey === materialKey) {
	          returnObj = sessionMaterial;
	        }
	      });
	
	      return returnObj;
	    }
	  }, {
	    key: "getSessionMaterial",
	    value: function getSessionMaterial(sessionMaterialKey) {
	      var materialToReturn = null;
	      this.gameSessionState.sessionMaterialList.forEach(function (sessionMaterial) {
	        if (sessionMaterial.key === sessionMaterialKey) {
	          materialToReturn = sessionMaterial;
	        }
	      });
	
	      return materialToReturn;
	    }
	  }, {
	    key: "getMaterial",
	    value: function getMaterial(materialKey) {
	      var materialToReturn = null;
	
	      this.materialList.forEach(function (material) {
	        if (material.key === materialKey) {
	          materialToReturn = material;
	        }
	      });
	
	      return materialToReturn;
	    }
	  }, {
	    key: "getMission",
	    value: function getMission(missionKey) {
	      var returnObj = null;
	
	      this.missionList.forEach(function (mission) {
	        if (mission.key === missionKey) {
	          returnObj = mission;
	        }
	      });
	
	      return returnObj;
	    }
	  }]);
	
	  return SessionModel;
	}();
	
	exports.default = SessionModel;

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2019-09-09 (15:49).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var log = __webpack_require__(4)();
	var SOCKET_STATES = {
	  CONNECTING: WebSocket ? WebSocket.CONNECTING : 0,
	  OPEN: WebSocket ? WebSocket.OPEN : 1,
	  CLOSING: WebSocket ? WebSocket.CLOSING : 2,
	  CLOSED: WebSocket ? WebSocket.CLOSED : 3
	};
	
	var WebSocketClient = function () {
	  function WebSocketClient(options) {
	    _classCallCheck(this, WebSocketClient);
	
	    this.url = options.url;
	    this.onOpen = options.onOpen;
	    this.onClose = options.onClose;
	    this.onError = options.onError;
	    this.onMessage = options.onMessage;
	  }
	
	  _createClass(WebSocketClient, [{
	    key: "open",
	    value: function open() {
	      var _this = this;
	
	      this.socket = new WebSocket(this.url);
	
	      this.socket.onopen = function (event) {
	        return _this._onOpen(event);
	      };
	      this.socket.onmessage = function (event) {
	        return _this._onMessage(event);
	      };
	      this.socket.onclose = function (event) {
	        return _this._onClose(event);
	      };
	      this.socket.onerror = function (event) {
	        return _this._onError(event);
	      };
	    }
	  }, {
	    key: "close",
	    value: function close(code, reason) {
	      if (_utils2.default.isNotNull(this.socket) && this.socket.readyState === SOCKET_STATES.OPEN) {
	        this.socket.close(code, reason);
	      }
	    }
	  }, {
	    key: "isConnected",
	    value: function isConnected() {
	      if (_utils2.default.isNotNull(this.socket)) {
	        return this.socket.readyState === SOCKET_STATES.OPEN;
	      }
	      return false;
	    }
	  }, {
	    key: "isClosed",
	    value: function isClosed() {
	      if (_utils2.default.isNotNull(this.socket)) {
	        return this.socket.readyState === SOCKET_STATES.CLOSED;
	      }
	      return false;
	    }
	  }, {
	    key: "sendData",
	    value: function sendData(data) {
	      if (_utils2.default.isNotNull(this.socket) && this.isConnected()) {
	        this.socket.send(data);
	      }
	    }
	  }, {
	    key: "_onOpen",
	    value: function _onOpen(event) {
	      log.debug("websocket connection established - %o", event);
	      if (_utils2.default.isFunction(this.onOpen)) {
	        this.onOpen.call(this, event);
	      }
	    }
	  }, {
	    key: "_onMessage",
	    value: function _onMessage(event) {
	      //log.debug("websocket messaged received - %o", event);
	      if (_utils2.default.isFunction(this.onMessage)) {
	        this.onMessage.call(this, event);
	      }
	    }
	  }, {
	    key: "_onClose",
	    value: function _onClose(event) {
	      log.debug("websocket connection closed - %o", event);
	      if (_utils2.default.isFunction(this.onClose)) {
	        this.onClose.call(this, event);
	      }
	    }
	  }, {
	    key: "_onError",
	    value: function _onError(event) {
	      log.error("websocket error occurred - %o", event);
	      if (_utils2.default.isFunction(this.onError)) {
	        this.onError.call(this, event);
	      }
	    }
	  }]);
	
	  return WebSocketClient;
	}();
	
	exports.default = WebSocketClient;

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RealtimeMessage = function () {
	  function RealtimeMessage(options) {
	    _classCallCheck(this, RealtimeMessage);
	
	    this.id = options.id || _utils2.default.UUID();
	    this.serviceName = options.serviceName;
	    this.type = options.type || "request";
	    this.params = options.params;
	    this.data = options.data;
	    this.errorCode = options.errorCode;
	    this.errorMessage = options.errorMessage;
	  }
	
	  _createClass(RealtimeMessage, [{
	    key: "serialize",
	    value: function serialize() {
	      var data = {
	        id: this.id,
	
	        type: this.type,
	        service: this.serviceName,
	        errorCode: this.errorCode,
	        errorMessage: this.errorMessage,
	        data: this.data,
	        params: this.params
	      };
	
	      return _utils2.default.stringifyJSON(data);
	    }
	  }], [{
	    key: "createRequest",
	    value: function createRequest(serviceName, params, data) {
	      return new RealtimeMessage({
	        serviceName: serviceName,
	        params: params,
	        data: data
	      });
	    }
	  }, {
	    key: "createResponse",
	    value: function createResponse(serviceName, params, data) {
	      return new RealtimeMessage({
	        type: "response",
	        serviceName: serviceName,
	        params: params,
	        data: data
	      });
	    }
	  }]);
	
	  return RealtimeMessage;
	}();
	
	exports.default = RealtimeMessage;

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _request = __webpack_require__(29);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AssignmentService = {};
	
	(function (AssignmentService) {
	  AssignmentService.getAllAssignments = function () {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/intermediate_assignments"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  AssignmentService.getAssignmentFile = function (key) {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/intermediate_assignments/" + key + "/file"),
	      cache: false
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	})(AssignmentService);
	
	module.exports = AssignmentService;

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _request = __webpack_require__(29);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaAssetService = {};
	
	(function (MediaAssetService) {
	  MediaAssetService.getAvatars = function () {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/media_assets/avatars"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(MediaAssetService.onServiceComplete);
	  };
	
	  MediaAssetService.getThumbs = function () {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/media_assets/thumbs"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON
	    }).then(MediaAssetService.onServiceComplete);
	  };
	
	  MediaAssetService.onServiceComplete = function (data) {
	    if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	      return data.data;
	    }
	
	    return null;
	  };
	})(MediaAssetService);
	
	module.exports = MediaAssetService;

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _request = __webpack_require__(29);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StudentService = {};
	
	(function (StudentService) {
	  StudentService.createStudent = function (classKey, studentName) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/students"),
	      cache: false,
	      data: {
	        "class-key": classKey,
	        "name": studentName
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  StudentService.updateStudent = function (studentKey, studentName) {
	    return _request2.default.put({
	      url: _utils2.default.getServiceUrl("/students/" + studentKey),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON,
	      data: {
	        key: studentKey,
	        name: studentName
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  StudentService.deleteStudent = function (studentKey) {
	    return _request2.default.delete({
	      url: _utils2.default.getServiceUrl("/students/" + studentKey),
	      cache: false
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (_utils2.default.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	})(StudentService);
	
	module.exports = StudentService;

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _missionObjective = __webpack_require__(264);
	
	var _missionObjective2 = _interopRequireDefault(_missionObjective);
	
	__webpack_require__(574);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import NavUtils from "Sources/utils/navigation-utils";
	var log = __webpack_require__(4)();
	
	var MissionObjective = function () {
	  function MissionObjective(options) {
	    _classCallCheck(this, MissionObjective);
	
	    this.$container = $(options.container);
	    this.hasRendered = false;
	    this.objective = options.objective;
	    this.onObjectiveSelected = options.onObjectiveSelected;
	    this.showCheckmark = options.showCheckmark;
	    this.selected = false;
	  }
	
	  _createClass(MissionObjective, [{
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var CHECKBOX_ID = ".objective-checkbox";
	      var INFINITE_BTN_ID = ".objective-infinite-btn";
	
	      var that = this;
	
	      this.$element.find(CHECKBOX_ID).on("change", function (e) {
	        if (e.target.checked) {
	          that.selected = true;
	        } else {
	          that.selected = false;
	        }
	        that.onObjectiveSelected();
	      });
	    }
	  }, {
	    key: "setUnselected",
	    value: function setUnselected() {
	      this.$element.find(".objective-checkbox").prop("checked", false);
	      this.selected = false;
	    }
	  }, {
	    key: "setSelected",
	    value: function setSelected() {
	      this.$element.find(".objective-checkbox").prop("checked", true);
	      this.selected = true;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	      this.$element = $(_missionObjective2.default);
	      this.$container.prepend(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	
	      this.updateMissionObjective();
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "closeAndUpdate",
	    value: function closeAndUpdate() {
	      this.updateMissionObjective();
	    }
	  }, {
	    key: "updateMissionObjective",
	    value: function updateMissionObjective() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var $objectiveName = this.$element.find("[data-bind-target='objective-name']");
	        $objectiveName.empty();
	
	        if (_utils2.default.isNotNull(this.objective) && _utils2.default.isNotNull(this.objective.code) && _utils2.default.isNotNull(this.objective.key)) {
	          $objectiveName.text(this.objective.code);
	          $objectiveName.attr("for", "objective-checkbox-" + this.objective.key);
	        }
	
	        var $objectiveCheckbox = this.$element.find("[data-bind-target='objective-checkbox']");
	        $objectiveCheckbox.empty();
	
	        if (_utils2.default.isNotNull(this.objective) && _utils2.default.isNotNull(this.objective.key)) {
	          $objectiveCheckbox.attr("id", "objective-checkbox-" + this.objective.key);
	        }
	      }
	    }
	  }, {
	    key: "objective",
	    get: function get() {
	      return this._objective;
	    },
	    set: function set(objective) {
	      this._objective = objective;
	      this.updateMissionObjective();
	    }
	  }], [{
	    key: "setUpMissionObjective",
	    value: function setUpMissionObjective(options) {
	      var instance = new MissionObjective(options);
	      instance.render();
	      if (options.selected) {
	        instance.setSelected();
	        //instance.onObjectiveSelected();
	      }
	
	      if (!options.showCheckmark) {
	        instance.$element.find("[data-bind-target='objective-checkbox']").hide();
	      }
	
	      instance.updateMissionObjective();
	
	      instance.setUpEventListeners();
	      return instance;
	    }
	  }]);
	
	  return MissionObjective;
	}();
	
	exports.default = MissionObjective;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 16/01/2017.
	 */
	var config = {
	  serviceBaseURL: "/services",
	  something: {}
	};
	
	if (false) {
	  config.something.something = "";
	} else {
	  config.something.something = "";
	}
	
	module.exports = config;

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 10/02/2021.
	 */
	var LanguageManager = __webpack_require__(6);
	var utils = __webpack_require__(2);
	
	//Require the css like any other css file
	__webpack_require__(259);
	
	__webpack_require__(329);
	
	var StorageController = __webpack_require__(21);
	var GoogleAnalytics = __webpack_require__(350); // requires the cookieconsent library like it was a script tag in the html
	// var cookieconsent = require("exports?cookieconsent!cookieconsent/build/cookieconsent.min.js"); // Doesn't rly do much, it still exposes cookieconsent to the window but it now also exports the value
	// import CC from "CookieConsent";
	
	var CookieconsentController = {};
	
	(function (CookieconsentController) {
	  CookieconsentController.initialize = function () {
	    var consentCookie = StorageController.getCookie(StorageController.keys.COOKIEPOLIYCY_ANALYTICS_CONSENT);
	
	    if (utils.isNull(consentCookie)) {
	      StorageController.removeCookie("cookieconsent_status");
	    }
	
	    window.cookieconsent.initialise({
	      "palette": {
	        "popup": {
	          "background": "#222222",
	          "text": "#ffffff"
	        },
	        "button": {
	          "background": "#7D6EE7",
	          "text": "#ffffff"
	        }
	      },
	      "theme": "classic",
	      "type": "opt-in",
	      "content": {
	        "message": LanguageManager.getValueForKey("cookies.message"),
	        "deny": LanguageManager.getValueForKey("cookies.button.deny.text"),
	        "allow": LanguageManager.getValueForKey("cookies.button.allow.text"),
	        "link": LanguageManager.getValueForKey("cookies.link.text"),
	        "href": LanguageManager.getValueForKey("cookies.link")
	      },
	      "cookie": {
	        "expiryDays": 365
	      },
	      "onStatusChange": function onStatusChange(status, chosenBefore) {
	        var enableCookies = status === "allow";
	        //console.log("User has chosen to '%s' cookies", (enableCookies ? "enabled" : "disable"));
	        StorageController.saveCookie(StorageController.keys.COOKIEPOLIYCY_ANALYTICS_CONSENT, enableCookies, 365);
	
	        if (enableCookies) {
	          onConsented();
	        } else {
	          onDeclined();
	        }
	      }
	    });
	  };
	
	  function onConsented() {
	    GoogleAnalytics.enable();
	    //GoogleAnalytics.triggerPageVisit();
	  }
	
	  function onDeclined() {
	    GoogleAnalytics.disable();
	  }
	})(CookieconsentController);
	
	module.exports = CookieconsentController;

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _storageController = __webpack_require__(21);
	
	var _storageController2 = _interopRequireDefault(_storageController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utils = __webpack_require__(2); /**
	                                             * Created by jv on 23/12/2016.
	                                             */
	
	var GoogleAnalytics = {};
	var TAG_ID = "G-B9142B03PK";
	
	$(function () {
	    GoogleAnalytics.addScriptIfConsented();
	});
	
	(function (GoogleAnalytics) {
	    GoogleAnalytics.hasConsented = function () {
	        return String(_storageController2.default.getCookie(_storageController2.default.keys.COOKIEPOLIYCY_ANALYTICS_CONSENT)) === "true";
	    };
	
	    GoogleAnalytics.enable = function () {
	        insertScriptTag();
	    };
	
	    GoogleAnalytics.disable = function () {
	        removeScriptTag();
	        removeGACookies();
	    };
	
	    GoogleAnalytics.addScriptIfConsented = function () {
	        if (GoogleAnalytics.hasConsented()) {
	            insertScriptTag();
	        }
	    };
	
	    function insertScriptTag() {
	
	        var script = document.createElement('script');
	        script.type = 'text/javascript';
	        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + TAG_ID;
	        $(script)[0].setAttribute("async", "");
	        document.head.appendChild(script);
	
	        window.dataLayer = window.dataLayer || [];
	
	        function gtag() {
	            window.dataLayer.push(arguments);
	        }
	
	        gtag('js', new Date());
	        gtag('config', TAG_ID);
	    }
	
	    function removeScriptTag() {
	        var $gaScriptEl = $("script[src='https://www.googletagmanager.com/gtag/js?id=" + TAG_ID + "']");
	        $gaScriptEl.remove();
	        if (!utils.isUndefined(window.dataLayer)) {
	            window.dataLayer = window.dataLayer.filter(function (x) {
	                return x[0] !== "js" && x[0] !== "config";
	            });
	        }
	    }
	
	    function removeGACookies() {
	        _storageController2.default.removeCookie("_ga");
	        _storageController2.default.removeCookie("_ga_" + TAG_ID);
	        _storageController2.default.removeCookie("_gid");
	    }
	})(GoogleAnalytics);
	
	module.exports = GoogleAnalytics;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 16/05/2017.
	 */
	var utils = __webpack_require__(2);
	
	var ANIMATION_DURATION = 300;
	
	module.exports = function () {
	  function DialogTemplate(options) {
	    _classCallCheck(this, DialogTemplate);
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.dialogId = utils.isNotNull(options.dialogId) ? options.dialogId : utils.generateUIDShort();
	    this.backdropIdSuffix = "-modal-backdrop";
	    this.title = options.title;
	    this.dialogContent = options.dialogContent;
	    this.disposable = utils.isBoolean(options.disposable) ? options.disposable : true;
	
	    this.confirmText = options.confirmText;
	    this.cancelText = options.cancelText;
	    this.cancelTopRight = utils.isBoolean(options.cancelTopRight) ? options.cancelTopRight : false;
	
	    this.onConfirm = options.onConfirm;
	    this.onCancel = options.onCancel;
	    this.onDispose = options.onDispose;
	
	    this.create();
	  }
	
	  _createClass(DialogTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.backdrop = "<div id='" + this.backdropId + "' class='modal-backdrop fade show'></div>";
	
	        this.dialogEl.appendTo("body");
	
	        if (this.disposable) {
	          this.addDisposeListener();
	        }
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.dialogEl = $("<div id='" + this.dialogId + "' class='modal fade' style='display: block;'>" + "<div class='modal-dialog'>" + "<div class='modal-content clearfix'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogHeader();
	      this.renderDialogContent();
	      this.renderDialogFooter();
	    }
	  }, {
	    key: "renderDialogHeader",
	    value: function renderDialogHeader() {
	      var dialogContentEl = this.dialogEl.find(".modal-content");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length) {
	        var dialogHeader = "<div class='modal-header'><h4 class='dialog-title'>" + this.title + "</h4></div>";
	        dialogContentEl.append(dialogHeader);
	      }
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      var dialogContentEl = this.dialogEl.find(".modal-content");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length) {
	        var dialogBodyEl = $("<div class='modal-body'></div>");
	        dialogBodyEl.append(this.dialogContent);
	
	        dialogContentEl.append(dialogBodyEl);
	      }
	    }
	  }, {
	    key: "renderDialogFooter",
	    value: function renderDialogFooter() {
	      var that = this;
	      var dialogContentEl = that.dialogEl.find(".modal-content");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length) {
	        var dialogFooterEl = $("<div class='modal-footer'></div>");
	
	        if (utils.isNotNull(that.confirmText)) {
	          var confirmBtn = $("<button class='btn btn-primary dialog-confirm-btn' type='button'>" + that.confirmText + "</button>");
	
	          confirmBtn.on("click", function (e) {
	            if (utils.isFunction(that.onConfirm)) {
	              that.onConfirm();
	            }
	          });
	
	          dialogFooterEl.append(confirmBtn);
	        }
	
	        if (utils.isNotNull(that.cancelText) || that.cancelTopRight === true) {
	          var classNames = "btn btn-primary dialog-cancel-btn";
	          var innerHTML = that.cancelText;
	
	          if (that.cancelTopRight) {
	            classNames = "btn btn-icon frameless cross-circle dark-grey pull-right";
	            innerHTML = "";
	          }
	
	          var cancelBtn = $("<button class='" + classNames + "' type='button'>" + innerHTML + "</button>");
	
	          cancelBtn.on("click", function () {
	            that.cancel();
	          });
	
	          if (that.cancelTopRight) {
	            that.dialogEl.find(".modal-content").prepend(cancelBtn);
	          } else {
	            dialogFooterEl.append(cancelBtn);
	          }
	        }
	
	        dialogContentEl.append(dialogFooterEl);
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      var that = this;
	
	      if (utils.isNotNull(that.dialogEl) && that.dialogEl.length && that._destroying !== true) {
	        that._destroying = true;
	
	        that.hide(function () {
	          that.dialogEl.remove();
	          that._initialized = false;
	          that._destroying = false;
	        });
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      var $body = $("body");
	      if (!$body.hasClass("modal-open")) {
	        $body.addClass("modal-open");
	      }
	
	      if (!this.backdropExists) {
	        $body.append(this.backdrop);
	      }
	
	      // Reading a css property forces layout to be computed
	      this.dialogEl.show().css("width");
	      this.dialogEl.addClass("show");
	    }
	  }, {
	    key: "hide",
	    value: function hide(callback) {
	      var that = this;
	      var $body = $("body");
	      if ($body.hasClass("modal-open")) {
	        $body.removeClass("modal-open");
	      }
	
	      $("#" + this.backdropId).remove();
	      this.dialogEl.removeClass("show");
	
	      setTimeout(function () {
	        that.dialogEl.hide();
	        if (utils.isFunction(callback)) {
	          callback();
	        }
	      }, ANIMATION_DURATION);
	    }
	  }, {
	    key: "cancel",
	    value: function cancel() {
	      this.hide();
	
	      if (utils.isFunction(this.onCancel)) {
	        this.onCancel();
	      }
	    }
	  }, {
	    key: "dispose",
	    value: function dispose() {
	      this.hide();
	
	      if (utils.isFunction(this.onDispose)) {
	        this.onDispose();
	      }
	    }
	  }, {
	    key: "addDisposeListener",
	    value: function addDisposeListener() {
	      var that = this;
	
	      that.dialogEl.off().on("click", function (e) {
	        if (e.target.className === "modal-content" || $(e.target).closest(".modal-content").length) {
	          e.stopPropagation();
	          return;
	        }
	
	        that.dispose();
	      });
	    }
	  }, {
	    key: "backdropId",
	    get: function get() {
	      return this.dialogId + this.backdropIdSuffix;
	    }
	  }, {
	    key: "backdropExists",
	    get: function get() {
	      return $("#" + this.backdropId).length;
	    }
	  }]);
	
	  return DialogTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(2);
	var LanguageManager = __webpack_require__(6);
	var DialogTemplate = __webpack_require__(353);
	
	var dialog = {};
	
	(function (Dialog) {
	  Dialog.showMessageDialog = function (options) {
	    var messageDialog = new DialogTemplate({
	      title: LanguageManager.getValueForKey(options.title),
	      dialogContent: LanguageManager.getValueForKey(options.message),
	      confirmText: LanguageManager.getValueForKey("modal.buttons.ok"),
	      disposable: options.disposable,
	      onConfirm: function onConfirm() {
	        messageDialog.destroy();
	
	        if (utils.isFunction(options.onConfirm)) {
	          options.onConfirm();
	        }
	      },
	      onCancel: function onCancel() {
	        messageDialog.destroy();
	      },
	      onDispose: function onDispose() {
	        messageDialog.destroy();
	
	        if (utils.isFunction(options.onDispose)) {
	          options.onDispose();
	        }
	      }
	    });
	
	    messageDialog.show();
	
	    return messageDialog;
	  };
	
	  Dialog.showOkCancelDialog = function (options) {
	    var okCancelDialog = new DialogTemplate({
	      title: LanguageManager.getValueForKey(options.title),
	      dialogContent: LanguageManager.getValueForKey(options.message),
	      confirmText: LanguageManager.getValueForKey("modal.buttons.ok"),
	      cancelText: LanguageManager.getValueForKey("modal.buttons.cancel"),
	      disposable: options.disposable,
	      onConfirm: function onConfirm() {
	        okCancelDialog.destroy();
	
	        if (utils.isFunction(options.onOk)) {
	          options.onOk();
	        }
	      },
	      onCancel: function onCancel() {
	        okCancelDialog.destroy();
	
	        if (utils.isFunction(options.onCancel)) {
	          options.onCancel();
	        }
	      },
	      onDispose: function onDispose() {
	        okCancelDialog.destroy();
	
	        if (utils.isFunction(options.onDispose)) {
	          options.onDispose();
	        }
	      }
	    });
	
	    okCancelDialog.show();
	
	    return okCancelDialog;
	  };
	
	  Dialog.showYesNoDialog = function (options) {
	    var yesNoDialog = new DialogTemplate({
	      title: LanguageManager.getValueForKey(options.title),
	      dialogContent: LanguageManager.getValueForKey(options.message),
	      confirmText: LanguageManager.getValueForKey("modal.buttons.yes"),
	      cancelText: LanguageManager.getValueForKey("modal.buttons.no"),
	      disposable: options.disposable,
	      onConfirm: function onConfirm() {
	        yesNoDialog.destroy();
	
	        if (utils.isFunction(options.onYes)) {
	          options.onYes();
	        }
	      },
	      onCancel: function onCancel() {
	        yesNoDialog.destroy();
	
	        if (utils.isFunction(options.onNo)) {
	          options.onNo();
	        }
	      },
	      onDispose: function onDispose() {
	        yesNoDialog.destroy();
	
	        if (utils.isFunction(options.onDispose)) {
	          options.onDispose();
	        }
	      }
	    });
	
	    yesNoDialog.show();
	
	    return yesNoDialog;
	  };
	})(dialog);
	
	module.exports = dialog;

/***/ })

});


// WEBPACK FOOTER //
// js/commons.04c378e77eb7bb625650.js